var varioSettings = [];
var varioCustomizer = {
    swatches: { size: "large", style: "circle", border_color: { normal: "#e4e4e4", active: "#4f5354" }, hover_effect: "none", image_position: "fit", border_style: "single", border_inner_color: { normal: "#fff", active: "#fff" } },
    sold_out: { show_sold_out_variants: true, style: "cross", hide_style: "automatic" },
    collection: { image_size: 240, swatch_size: "medium", show_label: true, limit_swatches: false, number_of_swatches: 0, number_of_buttons: 0, plus_button_action: "do_nothing" },
};
var VarioCurrencyFormat = "<span class=hidden>${{ amount }}</span>";
(() => {
    "use strict";
    function t(t) {
        if (null == t) return window;
        if ("[object Window]" !== t.toString()) {
            var e = t.ownerDocument;
            return (e && e.defaultView) || window;
        }
        return t;
    }
    function e(e) {
        return e instanceof t(e).Element || e instanceof Element;
    }
    function r(e) {
        return e instanceof t(e).HTMLElement || e instanceof HTMLElement;
    }
    function n(e) {
        return "undefined" != typeof ShadowRoot && (e instanceof t(e).ShadowRoot || e instanceof ShadowRoot);
    }
    var i = Math.max,
        o = Math.min,
        a = Math.round;
    function s(t, e) {
        void 0 === e && (e = !1);
        var n = t.getBoundingClientRect(),
            i = 1,
            o = 1;
        if (r(t) && e) {
            var s = t.offsetHeight,
                c = t.offsetWidth;
            c > 0 && (i = a(n.width) / c || 1), s > 0 && (o = a(n.height) / s || 1);
        }
        return { width: n.width / i, height: n.height / o, top: n.top / o, right: n.right / i, bottom: n.bottom / o, left: n.left / i, x: n.left / i, y: n.top / o };
    }
    function c(e) {
        var r = t(e);
        return { scrollLeft: r.pageXOffset, scrollTop: r.pageYOffset };
    }
    function u(t) {
        return t ? (t.nodeName || "").toLowerCase() : null;
    }
    function l(t) {
        return ((e(t) ? t.ownerDocument : t.document) || window.document).documentElement;
    }
    function p(t) {
        return s(l(t)).left + c(t).scrollLeft;
    }
    function f(e) {
        return t(e).getComputedStyle(e);
    }
    function d(t) {
        var e = f(t),
            r = e.overflow,
            n = e.overflowX,
            i = e.overflowY;
        return /auto|scroll|overlay|hidden/.test(r + i + n);
    }
    function h(e, n, i) {
        void 0 === i && (i = !1);
        var o,
            f,
            h = r(n),
            v =
                r(n) &&
                (function (t) {
                    var e = t.getBoundingClientRect(),
                        r = a(e.width) / t.offsetWidth || 1,
                        n = a(e.height) / t.offsetHeight || 1;
                    return 1 !== r || 1 !== n;
                })(n),
            m = l(n),
            y = s(e, v),
            g = { scrollLeft: 0, scrollTop: 0 },
            w = { x: 0, y: 0 };
        return (
            (h || (!h && !i)) &&
                (("body" !== u(n) || d(m)) && (g = (o = n) !== t(o) && r(o) ? { scrollLeft: (f = o).scrollLeft, scrollTop: f.scrollTop } : c(o)), r(n) ? (((w = s(n, !0)).x += n.clientLeft), (w.y += n.clientTop)) : m && (w.x = p(m))),
            { x: y.left + g.scrollLeft - w.x, y: y.top + g.scrollTop - w.y, width: y.width, height: y.height }
        );
    }
    function v(t) {
        var e = s(t),
            r = t.offsetWidth,
            n = t.offsetHeight;
        return Math.abs(e.width - r) <= 1 && (r = e.width), Math.abs(e.height - n) <= 1 && (n = e.height), { x: t.offsetLeft, y: t.offsetTop, width: r, height: n };
    }
    function m(t) {
        return "html" === u(t) ? t : t.assignedSlot || t.parentNode || (n(t) ? t.host : null) || l(t);
    }
    function y(t) {
        return ["html", "body", "#document"].indexOf(u(t)) >= 0 ? t.ownerDocument.body : r(t) && d(t) ? t : y(m(t));
    }
    function g(e, r) {
        var n;
        void 0 === r && (r = []);
        var i = y(e),
            o = i === (null == (n = e.ownerDocument) ? void 0 : n.body),
            a = t(i),
            s = o ? [a].concat(a.visualViewport || [], d(i) ? i : []) : i,
            c = r.concat(s);
        return o ? c : c.concat(g(m(s)));
    }
    function w(t) {
        return ["table", "td", "th"].indexOf(u(t)) >= 0;
    }
    function b(t) {
        return r(t) && "fixed" !== f(t).position ? t.offsetParent : null;
    }
    function _(e) {
        for (var n = t(e), i = b(e); i && w(i) && "static" === f(i).position; ) i = b(i);
        return i && ("html" === u(i) || ("body" === u(i) && "static" === f(i).position))
            ? n
            : i ||
                  (function (t) {
                      var e = -1 !== navigator.userAgent.toLowerCase().indexOf("firefox");
                      if (-1 !== navigator.userAgent.indexOf("Trident") && r(t) && "fixed" === f(t).position) return null;
                      for (var n = m(t); r(n) && ["html", "body"].indexOf(u(n)) < 0; ) {
                          var i = f(n);
                          if (
                              "none" !== i.transform ||
                              "none" !== i.perspective ||
                              "paint" === i.contain ||
                              -1 !== ["transform", "perspective"].indexOf(i.willChange) ||
                              (e && "filter" === i.willChange) ||
                              (e && i.filter && "none" !== i.filter)
                          )
                              return n;
                          n = n.parentNode;
                      }
                      return null;
                  })(e) ||
                  n;
    }
    var S = "top",
        k = "bottom",
        x = "right",
        T = "left",
        q = "auto",
        O = [S, k, x, T],
        E = "start",
        L = "end",
        P = "viewport",
        A = "popper",
        F = O.reduce(function (t, e) {
            return t.concat([e + "-" + E, e + "-" + L]);
        }, []),
        N = [].concat(O, [q]).reduce(function (t, e) {
            return t.concat([e, e + "-" + E, e + "-" + L]);
        }, []),
        j = ["beforeRead", "read", "afterRead", "beforeMain", "main", "afterMain", "beforeWrite", "write", "afterWrite"];
    function C(t) {
        var e = new Map(),
            r = new Set(),
            n = [];
        function i(t) {
            r.add(t.name),
                [].concat(t.requires || [], t.requiresIfExists || []).forEach(function (t) {
                    if (!r.has(t)) {
                        var n = e.get(t);
                        n && i(n);
                    }
                }),
                n.push(t);
        }
        return (
            t.forEach(function (t) {
                e.set(t.name, t);
            }),
            t.forEach(function (t) {
                r.has(t.name) || i(t);
            }),
            n
        );
    }
    var R = { placement: "bottom", modifiers: [], strategy: "absolute" };
    function D() {
        for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++) e[r] = arguments[r];
        return !e.some(function (t) {
            return !(t && "function" == typeof t.getBoundingClientRect);
        });
    }
    function V(t) {
        void 0 === t && (t = {});
        var r = t,
            n = r.defaultModifiers,
            i = void 0 === n ? [] : n,
            o = r.defaultOptions,
            a = void 0 === o ? R : o;
        return function (t, r, n) {
            void 0 === n && (n = a);
            var o,
                s,
                c = { placement: "bottom", orderedModifiers: [], options: Object.assign({}, R, a), modifiersData: {}, elements: { reference: t, popper: r }, attributes: {}, styles: {} },
                u = [],
                l = !1,
                p = {
                    state: c,
                    setOptions: function (n) {
                        var o = "function" == typeof n ? n(c.options) : n;
                        f(), (c.options = Object.assign({}, a, c.options, o)), (c.scrollParents = { reference: e(t) ? g(t) : t.contextElement ? g(t.contextElement) : [], popper: g(r) });
                        var s = (function (t) {
                            var e = C(t);
                            return j.reduce(function (t, r) {
                                return t.concat(
                                    e.filter(function (t) {
                                        return t.phase === r;
                                    })
                                );
                            }, []);
                        })(
                            (function (t) {
                                var e = t.reduce(function (t, e) {
                                    var r = t[e.name];
                                    return (t[e.name] = r ? Object.assign({}, r, e, { options: Object.assign({}, r.options, e.options), data: Object.assign({}, r.data, e.data) }) : e), t;
                                }, {});
                                return Object.keys(e).map(function (t) {
                                    return e[t];
                                });
                            })([].concat(i, c.options.modifiers))
                        );
                        return (
                            (c.orderedModifiers = s.filter(function (t) {
                                return t.enabled;
                            })),
                            c.orderedModifiers.forEach(function (t) {
                                var e = t.name,
                                    r = t.options,
                                    n = void 0 === r ? {} : r,
                                    i = t.effect;
                                if ("function" == typeof i) {
                                    var o = i({ state: c, name: e, instance: p, options: n }),
                                        a = function () {};
                                    u.push(o || a);
                                }
                            }),
                            p.update()
                        );
                    },
                    forceUpdate: function () {
                        if (!l) {
                            var t = c.elements,
                                e = t.reference,
                                r = t.popper;
                            if (D(e, r)) {
                                (c.rects = { reference: h(e, _(r), "fixed" === c.options.strategy), popper: v(r) }),
                                    (c.reset = !1),
                                    (c.placement = c.options.placement),
                                    c.orderedModifiers.forEach(function (t) {
                                        return (c.modifiersData[t.name] = Object.assign({}, t.data));
                                    });
                                for (var n = 0; n < c.orderedModifiers.length; n++)
                                    if (!0 !== c.reset) {
                                        var i = c.orderedModifiers[n],
                                            o = i.fn,
                                            a = i.options,
                                            s = void 0 === a ? {} : a,
                                            u = i.name;
                                        "function" == typeof o && (c = o({ state: c, options: s, name: u, instance: p }) || c);
                                    } else (c.reset = !1), (n = -1);
                            }
                        }
                    },
                    update:
                        ((o = function () {
                            return new Promise(function (t) {
                                p.forceUpdate(), t(c);
                            });
                        }),
                        function () {
                            return (
                                s ||
                                    (s = new Promise(function (t) {
                                        Promise.resolve().then(function () {
                                            (s = void 0), t(o());
                                        });
                                    })),
                                s
                            );
                        }),
                    destroy: function () {
                        f(), (l = !0);
                    },
                };
            if (!D(t, r)) return p;
            function f() {
                u.forEach(function (t) {
                    return t();
                }),
                    (u = []);
            }
            return (
                p.setOptions(n).then(function (t) {
                    !l && n.onFirstUpdate && n.onFirstUpdate(t);
                }),
                p
            );
        };
    }
    var M = { passive: !0 };
    function I(t) {
        return t.split("-")[0];
    }
    function B(t) {
        return t.split("-")[1];
    }
    function z(t) {
        return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
    }
    function H(t) {
        var e,
            r = t.reference,
            n = t.element,
            i = t.placement,
            o = i ? I(i) : null,
            a = i ? B(i) : null,
            s = r.x + r.width / 2 - n.width / 2,
            c = r.y + r.height / 2 - n.height / 2;
        switch (o) {
            case S:
                e = { x: s, y: r.y - n.height };
                break;
            case k:
                e = { x: s, y: r.y + r.height };
                break;
            case x:
                e = { x: r.x + r.width, y: c };
                break;
            case T:
                e = { x: r.x - n.width, y: c };
                break;
            default:
                e = { x: r.x, y: r.y };
        }
        var u = o ? z(o) : null;
        if (null != u) {
            var l = "y" === u ? "height" : "width";
            switch (a) {
                case E:
                    e[u] = e[u] - (r[l] / 2 - n[l] / 2);
                    break;
                case L:
                    e[u] = e[u] + (r[l] / 2 - n[l] / 2);
            }
        }
        return e;
    }
    var W = { top: "auto", right: "auto", bottom: "auto", left: "auto" };
    function U(e) {
        var r,
            n = e.popper,
            i = e.popperRect,
            o = e.placement,
            s = e.variation,
            c = e.offsets,
            u = e.position,
            p = e.gpuAcceleration,
            d = e.adaptive,
            h = e.roundOffsets,
            v = e.isFixed,
            m = c.x,
            y = void 0 === m ? 0 : m,
            g = c.y,
            w = void 0 === g ? 0 : g,
            b = "function" == typeof h ? h({ x: y, y: w }) : { x: y, y: w };
        (y = b.x), (w = b.y);
        var q = c.hasOwnProperty("x"),
            O = c.hasOwnProperty("y"),
            E = T,
            P = S,
            A = window;
        if (d) {
            var F = _(n),
                N = "clientHeight",
                j = "clientWidth";
            if ((F === t(n) && "static" !== f((F = l(n))).position && "absolute" === u && ((N = "scrollHeight"), (j = "scrollWidth")), (F = F), o === S || ((o === T || o === x) && s === L)))
                (P = k), (w -= (v && A.visualViewport ? A.visualViewport.height : F[N]) - i.height), (w *= p ? 1 : -1);
            if (o === T || ((o === S || o === k) && s === L)) (E = x), (y -= (v && A.visualViewport ? A.visualViewport.width : F[j]) - i.width), (y *= p ? 1 : -1);
        }
        var C,
            R = Object.assign({ position: u }, d && W),
            D =
                !0 === h
                    ? (function (t) {
                          var e = t.x,
                              r = t.y,
                              n = window.devicePixelRatio || 1;
                          return { x: a(e * n) / n || 0, y: a(r * n) / n || 0 };
                      })({ x: y, y: w })
                    : { x: y, y: w };
        return (
            (y = D.x),
            (w = D.y),
            p
                ? Object.assign({}, R, (((C = {})[P] = O ? "0" : ""), (C[E] = q ? "0" : ""), (C.transform = (A.devicePixelRatio || 1) <= 1 ? "translate(" + y + "px, " + w + "px)" : "translate3d(" + y + "px, " + w + "px, 0)"), C))
                : Object.assign({}, R, (((r = {})[P] = O ? w + "px" : ""), (r[E] = q ? y + "px" : ""), (r.transform = ""), r))
        );
    }
    const J = {
        name: "offset",
        enabled: !0,
        phase: "main",
        requires: ["popperOffsets"],
        fn: function (t) {
            var e = t.state,
                r = t.options,
                n = t.name,
                i = r.offset,
                o = void 0 === i ? [0, 0] : i,
                a = N.reduce(function (t, r) {
                    return (
                        (t[r] = (function (t, e, r) {
                            var n = I(t),
                                i = [T, S].indexOf(n) >= 0 ? -1 : 1,
                                o = "function" == typeof r ? r(Object.assign({}, e, { placement: t })) : r,
                                a = o[0],
                                s = o[1];
                            return (a = a || 0), (s = (s || 0) * i), [T, x].indexOf(n) >= 0 ? { x: s, y: a } : { x: a, y: s };
                        })(r, e.rects, o)),
                        t
                    );
                }, {}),
                s = a[e.placement],
                c = s.x,
                u = s.y;
            null != e.modifiersData.popperOffsets && ((e.modifiersData.popperOffsets.x += c), (e.modifiersData.popperOffsets.y += u)), (e.modifiersData[n] = a);
        },
    };
    var Y = { left: "right", right: "left", bottom: "top", top: "bottom" };
    function Q(t) {
        return t.replace(/left|right|bottom|top/g, function (t) {
            return Y[t];
        });
    }
    var $ = { start: "end", end: "start" };
    function X(t) {
        return t.replace(/start|end/g, function (t) {
            return $[t];
        });
    }
    function G(t, e) {
        var r = e.getRootNode && e.getRootNode();
        if (t.contains(e)) return !0;
        if (r && n(r)) {
            var i = e;
            do {
                if (i && t.isSameNode(i)) return !0;
                i = i.parentNode || i.host;
            } while (i);
        }
        return !1;
    }
    function Z(t) {
        return Object.assign({}, t, { left: t.x, top: t.y, right: t.x + t.width, bottom: t.y + t.height });
    }
    function K(r, n) {
        return n === P
            ? Z(
                  (function (e) {
                      var r = t(e),
                          n = l(e),
                          i = r.visualViewport,
                          o = n.clientWidth,
                          a = n.clientHeight,
                          s = 0,
                          c = 0;
                      return i && ((o = i.width), (a = i.height), /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || ((s = i.offsetLeft), (c = i.offsetTop))), { width: o, height: a, x: s + p(e), y: c };
                  })(r)
              )
            : e(n)
            ? (function (t) {
                  var e = s(t);
                  return (
                      (e.top = e.top + t.clientTop),
                      (e.left = e.left + t.clientLeft),
                      (e.bottom = e.top + t.clientHeight),
                      (e.right = e.left + t.clientWidth),
                      (e.width = t.clientWidth),
                      (e.height = t.clientHeight),
                      (e.x = e.left),
                      (e.y = e.top),
                      e
                  );
              })(n)
            : Z(
                  (function (t) {
                      var e,
                          r = l(t),
                          n = c(t),
                          o = null == (e = t.ownerDocument) ? void 0 : e.body,
                          a = i(r.scrollWidth, r.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0),
                          s = i(r.scrollHeight, r.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0),
                          u = -n.scrollLeft + p(t),
                          d = -n.scrollTop;
                      return "rtl" === f(o || r).direction && (u += i(r.clientWidth, o ? o.clientWidth : 0) - a), { width: a, height: s, x: u, y: d };
                  })(l(r))
              );
    }
    function tt(t, n, a) {
        var s =
                "clippingParents" === n
                    ? (function (t) {
                          var n = g(m(t)),
                              i = ["absolute", "fixed"].indexOf(f(t).position) >= 0 && r(t) ? _(t) : t;
                          return e(i)
                              ? n.filter(function (t) {
                                    return e(t) && G(t, i) && "body" !== u(t);
                                })
                              : [];
                      })(t)
                    : [].concat(n),
            c = [].concat(s, [a]),
            l = c[0],
            p = c.reduce(function (e, r) {
                var n = K(t, r);
                return (e.top = i(n.top, e.top)), (e.right = o(n.right, e.right)), (e.bottom = o(n.bottom, e.bottom)), (e.left = i(n.left, e.left)), e;
            }, K(t, l));
        return (p.width = p.right - p.left), (p.height = p.bottom - p.top), (p.x = p.left), (p.y = p.top), p;
    }
    function et(t) {
        return Object.assign({}, { top: 0, right: 0, bottom: 0, left: 0 }, t);
    }
    function rt(t, e) {
        return e.reduce(function (e, r) {
            return (e[r] = t), e;
        }, {});
    }
    function nt(t, r) {
        void 0 === r && (r = {});
        var n = r,
            i = n.placement,
            o = void 0 === i ? t.placement : i,
            a = n.boundary,
            c = void 0 === a ? "clippingParents" : a,
            u = n.rootBoundary,
            p = void 0 === u ? P : u,
            f = n.elementContext,
            d = void 0 === f ? A : f,
            h = n.altBoundary,
            v = void 0 !== h && h,
            m = n.padding,
            y = void 0 === m ? 0 : m,
            g = et("number" != typeof y ? y : rt(y, O)),
            w = d === A ? "reference" : A,
            b = t.rects.popper,
            _ = t.elements[v ? w : d],
            T = tt(e(_) ? _ : _.contextElement || l(t.elements.popper), c, p),
            q = s(t.elements.reference),
            E = H({ reference: q, element: b, strategy: "absolute", placement: o }),
            L = Z(Object.assign({}, b, E)),
            F = d === A ? L : q,
            N = { top: T.top - F.top + g.top, bottom: F.bottom - T.bottom + g.bottom, left: T.left - F.left + g.left, right: F.right - T.right + g.right },
            j = t.modifiersData.offset;
        if (d === A && j) {
            var C = j[o];
            Object.keys(N).forEach(function (t) {
                var e = [x, k].indexOf(t) >= 0 ? 1 : -1,
                    r = [S, k].indexOf(t) >= 0 ? "y" : "x";
                N[t] += C[r] * e;
            });
        }
        return N;
    }
    function it(t, e, r) {
        return i(t, o(e, r));
    }
    const ot = {
        name: "preventOverflow",
        enabled: !0,
        phase: "main",
        fn: function (t) {
            var e = t.state,
                r = t.options,
                n = t.name,
                a = r.mainAxis,
                s = void 0 === a || a,
                c = r.altAxis,
                u = void 0 !== c && c,
                l = r.boundary,
                p = r.rootBoundary,
                f = r.altBoundary,
                d = r.padding,
                h = r.tether,
                m = void 0 === h || h,
                y = r.tetherOffset,
                g = void 0 === y ? 0 : y,
                w = nt(e, { boundary: l, rootBoundary: p, padding: d, altBoundary: f }),
                b = I(e.placement),
                q = B(e.placement),
                O = !q,
                L = z(b),
                P = "x" === L ? "y" : "x",
                A = e.modifiersData.popperOffsets,
                F = e.rects.reference,
                N = e.rects.popper,
                j = "function" == typeof g ? g(Object.assign({}, e.rects, { placement: e.placement })) : g,
                C = "number" == typeof j ? { mainAxis: j, altAxis: j } : Object.assign({ mainAxis: 0, altAxis: 0 }, j),
                R = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null,
                D = { x: 0, y: 0 };
            if (A) {
                if (s) {
                    var V,
                        M = "y" === L ? S : T,
                        H = "y" === L ? k : x,
                        W = "y" === L ? "height" : "width",
                        U = A[L],
                        J = U + w[M],
                        Y = U - w[H],
                        Q = m ? -N[W] / 2 : 0,
                        $ = q === E ? F[W] : N[W],
                        X = q === E ? -N[W] : -F[W],
                        G = e.elements.arrow,
                        Z = m && G ? v(G) : { width: 0, height: 0 },
                        K = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : { top: 0, right: 0, bottom: 0, left: 0 },
                        tt = K[M],
                        et = K[H],
                        rt = it(0, F[W], Z[W]),
                        ot = O ? F[W] / 2 - Q - rt - tt - C.mainAxis : $ - rt - tt - C.mainAxis,
                        at = O ? -F[W] / 2 + Q + rt + et + C.mainAxis : X + rt + et + C.mainAxis,
                        st = e.elements.arrow && _(e.elements.arrow),
                        ct = st ? ("y" === L ? st.clientTop || 0 : st.clientLeft || 0) : 0,
                        ut = null != (V = null == R ? void 0 : R[L]) ? V : 0,
                        lt = U + at - ut,
                        pt = it(m ? o(J, U + ot - ut - ct) : J, U, m ? i(Y, lt) : Y);
                    (A[L] = pt), (D[L] = pt - U);
                }
                if (u) {
                    var ft,
                        dt = "x" === L ? S : T,
                        ht = "x" === L ? k : x,
                        vt = A[P],
                        mt = "y" === P ? "height" : "width",
                        yt = vt + w[dt],
                        gt = vt - w[ht],
                        wt = -1 !== [S, T].indexOf(b),
                        bt = null != (ft = null == R ? void 0 : R[P]) ? ft : 0,
                        _t = wt ? yt : vt - F[mt] - N[mt] - bt + C.altAxis,
                        St = wt ? vt + F[mt] + N[mt] - bt - C.altAxis : gt,
                        kt =
                            m && wt
                                ? (function (t, e, r) {
                                      var n = it(t, e, r);
                                      return n > r ? r : n;
                                  })(_t, vt, St)
                                : it(m ? _t : yt, vt, m ? St : gt);
                    (A[P] = kt), (D[P] = kt - vt);
                }
                e.modifiersData[n] = D;
            }
        },
        requiresIfExists: ["offset"],
    };
    const at = {
        name: "arrow",
        enabled: !0,
        phase: "main",
        fn: function (t) {
            var e,
                r = t.state,
                n = t.name,
                i = t.options,
                o = r.elements.arrow,
                a = r.modifiersData.popperOffsets,
                s = I(r.placement),
                c = z(s),
                u = [T, x].indexOf(s) >= 0 ? "height" : "width";
            if (o && a) {
                var l = (function (t, e) {
                        return et("number" != typeof (t = "function" == typeof t ? t(Object.assign({}, e.rects, { placement: e.placement })) : t) ? t : rt(t, O));
                    })(i.padding, r),
                    p = v(o),
                    f = "y" === c ? S : T,
                    d = "y" === c ? k : x,
                    h = r.rects.reference[u] + r.rects.reference[c] - a[c] - r.rects.popper[u],
                    m = a[c] - r.rects.reference[c],
                    y = _(o),
                    g = y ? ("y" === c ? y.clientHeight || 0 : y.clientWidth || 0) : 0,
                    w = h / 2 - m / 2,
                    b = l[f],
                    q = g - p[u] - l[d],
                    E = g / 2 - p[u] / 2 + w,
                    L = it(b, E, q),
                    P = c;
                r.modifiersData[n] = (((e = {})[P] = L), (e.centerOffset = L - E), e);
            }
        },
        effect: function (t) {
            var e = t.state,
                r = t.options.element,
                n = void 0 === r ? "[data-popper-arrow]" : r;
            null != n && ("string" != typeof n || (n = e.elements.popper.querySelector(n))) && G(e.elements.popper, n) && (e.elements.arrow = n);
        },
        requires: ["popperOffsets"],
        requiresIfExists: ["preventOverflow"],
    };
    function st(t, e, r) {
        return void 0 === r && (r = { x: 0, y: 0 }), { top: t.top - e.height - r.y, right: t.right - e.width + r.x, bottom: t.bottom - e.height + r.y, left: t.left - e.width - r.x };
    }
    function ct(t) {
        return [S, x, k, T].some(function (e) {
            return t[e] >= 0;
        });
    }
    var ut = V({
            defaultModifiers: [
                {
                    name: "eventListeners",
                    enabled: !0,
                    phase: "write",
                    fn: function () {},
                    effect: function (e) {
                        var r = e.state,
                            n = e.instance,
                            i = e.options,
                            o = i.scroll,
                            a = void 0 === o || o,
                            s = i.resize,
                            c = void 0 === s || s,
                            u = t(r.elements.popper),
                            l = [].concat(r.scrollParents.reference, r.scrollParents.popper);
                        return (
                            a &&
                                l.forEach(function (t) {
                                    t.addEventListener("scroll", n.update, M);
                                }),
                            c && u.addEventListener("resize", n.update, M),
                            function () {
                                a &&
                                    l.forEach(function (t) {
                                        t.removeEventListener("scroll", n.update, M);
                                    }),
                                    c && u.removeEventListener("resize", n.update, M);
                            }
                        );
                    },
                    data: {},
                },
                {
                    name: "popperOffsets",
                    enabled: !0,
                    phase: "read",
                    fn: function (t) {
                        var e = t.state,
                            r = t.name;
                        e.modifiersData[r] = H({ reference: e.rects.reference, element: e.rects.popper, strategy: "absolute", placement: e.placement });
                    },
                    data: {},
                },
                {
                    name: "computeStyles",
                    enabled: !0,
                    phase: "beforeWrite",
                    fn: function (t) {
                        var e = t.state,
                            r = t.options,
                            n = r.gpuAcceleration,
                            i = void 0 === n || n,
                            o = r.adaptive,
                            a = void 0 === o || o,
                            s = r.roundOffsets,
                            c = void 0 === s || s,
                            u = { placement: I(e.placement), variation: B(e.placement), popper: e.elements.popper, popperRect: e.rects.popper, gpuAcceleration: i, isFixed: "fixed" === e.options.strategy };
                        null != e.modifiersData.popperOffsets &&
                            (e.styles.popper = Object.assign({}, e.styles.popper, U(Object.assign({}, u, { offsets: e.modifiersData.popperOffsets, position: e.options.strategy, adaptive: a, roundOffsets: c })))),
                            null != e.modifiersData.arrow && (e.styles.arrow = Object.assign({}, e.styles.arrow, U(Object.assign({}, u, { offsets: e.modifiersData.arrow, position: "absolute", adaptive: !1, roundOffsets: c })))),
                            (e.attributes.popper = Object.assign({}, e.attributes.popper, { "data-popper-placement": e.placement }));
                    },
                    data: {},
                },
                {
                    name: "applyStyles",
                    enabled: !0,
                    phase: "write",
                    fn: function (t) {
                        var e = t.state;
                        Object.keys(e.elements).forEach(function (t) {
                            var n = e.styles[t] || {},
                                i = e.attributes[t] || {},
                                o = e.elements[t];
                            r(o) &&
                                u(o) &&
                                (Object.assign(o.style, n),
                                Object.keys(i).forEach(function (t) {
                                    var e = i[t];
                                    !1 === e ? o.removeAttribute(t) : o.setAttribute(t, !0 === e ? "" : e);
                                }));
                        });
                    },
                    effect: function (t) {
                        var e = t.state,
                            n = { popper: { position: e.options.strategy, left: "0", top: "0", margin: "0" }, arrow: { position: "absolute" }, reference: {} };
                        return (
                            Object.assign(e.elements.popper.style, n.popper),
                            (e.styles = n),
                            e.elements.arrow && Object.assign(e.elements.arrow.style, n.arrow),
                            function () {
                                Object.keys(e.elements).forEach(function (t) {
                                    var i = e.elements[t],
                                        o = e.attributes[t] || {},
                                        a = Object.keys(e.styles.hasOwnProperty(t) ? e.styles[t] : n[t]).reduce(function (t, e) {
                                            return (t[e] = ""), t;
                                        }, {});
                                    r(i) &&
                                        u(i) &&
                                        (Object.assign(i.style, a),
                                        Object.keys(o).forEach(function (t) {
                                            i.removeAttribute(t);
                                        }));
                                });
                            }
                        );
                    },
                    requires: ["computeStyles"],
                },
                J,
                {
                    name: "flip",
                    enabled: !0,
                    phase: "main",
                    fn: function (t) {
                        var e = t.state,
                            r = t.options,
                            n = t.name;
                        if (!e.modifiersData[n]._skip) {
                            for (
                                var i = r.mainAxis,
                                    o = void 0 === i || i,
                                    a = r.altAxis,
                                    s = void 0 === a || a,
                                    c = r.fallbackPlacements,
                                    u = r.padding,
                                    l = r.boundary,
                                    p = r.rootBoundary,
                                    f = r.altBoundary,
                                    d = r.flipVariations,
                                    h = void 0 === d || d,
                                    v = r.allowedAutoPlacements,
                                    m = e.options.placement,
                                    y = I(m),
                                    g =
                                        c ||
                                        (y === m || !h
                                            ? [Q(m)]
                                            : (function (t) {
                                                  if (I(t) === q) return [];
                                                  var e = Q(t);
                                                  return [X(t), e, X(e)];
                                              })(m)),
                                    w = [m].concat(g).reduce(function (t, r) {
                                        return t.concat(
                                            I(r) === q
                                                ? (function (t, e) {
                                                      void 0 === e && (e = {});
                                                      var r = e,
                                                          n = r.placement,
                                                          i = r.boundary,
                                                          o = r.rootBoundary,
                                                          a = r.padding,
                                                          s = r.flipVariations,
                                                          c = r.allowedAutoPlacements,
                                                          u = void 0 === c ? N : c,
                                                          l = B(n),
                                                          p = l
                                                              ? s
                                                                  ? F
                                                                  : F.filter(function (t) {
                                                                        return B(t) === l;
                                                                    })
                                                              : O,
                                                          f = p.filter(function (t) {
                                                              return u.indexOf(t) >= 0;
                                                          });
                                                      0 === f.length && (f = p);
                                                      var d = f.reduce(function (e, r) {
                                                          return (e[r] = nt(t, { placement: r, boundary: i, rootBoundary: o, padding: a })[I(r)]), e;
                                                      }, {});
                                                      return Object.keys(d).sort(function (t, e) {
                                                          return d[t] - d[e];
                                                      });
                                                  })(e, { placement: r, boundary: l, rootBoundary: p, padding: u, flipVariations: h, allowedAutoPlacements: v })
                                                : r
                                        );
                                    }, []),
                                    b = e.rects.reference,
                                    _ = e.rects.popper,
                                    L = new Map(),
                                    P = !0,
                                    A = w[0],
                                    j = 0;
                                j < w.length;
                                j++
                            ) {
                                var C = w[j],
                                    R = I(C),
                                    D = B(C) === E,
                                    V = [S, k].indexOf(R) >= 0,
                                    M = V ? "width" : "height",
                                    z = nt(e, { placement: C, boundary: l, rootBoundary: p, altBoundary: f, padding: u }),
                                    H = V ? (D ? x : T) : D ? k : S;
                                b[M] > _[M] && (H = Q(H));
                                var W = Q(H),
                                    U = [];
                                if (
                                    (o && U.push(z[R] <= 0),
                                    s && U.push(z[H] <= 0, z[W] <= 0),
                                    U.every(function (t) {
                                        return t;
                                    }))
                                ) {
                                    (A = C), (P = !1);
                                    break;
                                }
                                L.set(C, U);
                            }
                            if (P)
                                for (
                                    var J = function (t) {
                                            var e = w.find(function (e) {
                                                var r = L.get(e);
                                                if (r)
                                                    return r.slice(0, t).every(function (t) {
                                                        return t;
                                                    });
                                            });
                                            if (e) return (A = e), "break";
                                        },
                                        Y = h ? 3 : 1;
                                    Y > 0;
                                    Y--
                                ) {
                                    if ("break" === J(Y)) break;
                                }
                            e.placement !== A && ((e.modifiersData[n]._skip = !0), (e.placement = A), (e.reset = !0));
                        }
                    },
                    requiresIfExists: ["offset"],
                    data: { _skip: !1 },
                },
                ot,
                at,
                {
                    name: "hide",
                    enabled: !0,
                    phase: "main",
                    requiresIfExists: ["preventOverflow"],
                    fn: function (t) {
                        var e = t.state,
                            r = t.name,
                            n = e.rects.reference,
                            i = e.rects.popper,
                            o = e.modifiersData.preventOverflow,
                            a = nt(e, { elementContext: "reference" }),
                            s = nt(e, { altBoundary: !0 }),
                            c = st(a, n),
                            u = st(s, i, o),
                            l = ct(c),
                            p = ct(u);
                        (e.modifiersData[r] = { referenceClippingOffsets: c, popperEscapeOffsets: u, isReferenceHidden: l, hasPopperEscaped: p }),
                            (e.attributes.popper = Object.assign({}, e.attributes.popper, { "data-popper-reference-hidden": l, "data-popper-escaped": p }));
                    },
                },
            ],
        }),
        lt = function (t, e) {
            return (
                (lt =
                    Object.setPrototypeOf ||
                    ({ __proto__: [] } instanceof Array &&
                        function (t, e) {
                            t.__proto__ = e;
                        }) ||
                    function (t, e) {
                        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
                    }),
                lt(t, e)
            );
        };
    function pt(t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
        function r() {
            this.constructor = t;
        }
        lt(t, e), (t.prototype = null === e ? Object.create(e) : ((r.prototype = e.prototype), new r()));
    }
    var ft = function () {
        return (
            (ft =
                Object.assign ||
                function (t) {
                    for (var e, r = 1, n = arguments.length; r < n; r++) for (var i in (e = arguments[r])) Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
                    return t;
                }),
            ft.apply(this, arguments)
        );
    };
    function dt(t, e, r, n) {
        return new (r || (r = Promise))(function (i, o) {
            function a(t) {
                try {
                    c(n.next(t));
                } catch (t) {
                    o(t);
                }
            }
            function s(t) {
                try {
                    c(n.throw(t));
                } catch (t) {
                    o(t);
                }
            }
            function c(t) {
                var e;
                t.done
                    ? i(t.value)
                    : ((e = t.value),
                      e instanceof r
                          ? e
                          : new r(function (t) {
                                t(e);
                            })).then(a, s);
            }
            c((n = n.apply(t, e || [])).next());
        });
    }
    function ht(t, e) {
        var r,
            n,
            i,
            o,
            a = {
                label: 0,
                sent: function () {
                    if (1 & i[0]) throw i[1];
                    return i[1];
                },
                trys: [],
                ops: [],
            };
        return (
            (o = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
                (o[Symbol.iterator] = function () {
                    return this;
                }),
            o
        );
        function s(o) {
            return function (s) {
                return (function (o) {
                    if (r) throw new TypeError("Generator is already executing.");
                    for (; a; )
                        try {
                            if (((r = 1), n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done)) return i;
                            switch (((n = 0), i && (o = [2 & o[0], i.value]), o[0])) {
                                case 0:
                                case 1:
                                    i = o;
                                    break;
                                case 4:
                                    return a.label++, { value: o[1], done: !1 };
                                case 5:
                                    a.label++, (n = o[1]), (o = [0]);
                                    continue;
                                case 7:
                                    (o = a.ops.pop()), a.trys.pop();
                                    continue;
                                default:
                                    if (!((i = a.trys), (i = i.length > 0 && i[i.length - 1]) || (6 !== o[0] && 2 !== o[0]))) {
                                        a = 0;
                                        continue;
                                    }
                                    if (3 === o[0] && (!i || (o[1] > i[0] && o[1] < i[3]))) {
                                        a.label = o[1];
                                        break;
                                    }
                                    if (6 === o[0] && a.label < i[1]) {
                                        (a.label = i[1]), (i = o);
                                        break;
                                    }
                                    if (i && a.label < i[2]) {
                                        (a.label = i[2]), a.ops.push(o);
                                        break;
                                    }
                                    i[2] && a.ops.pop(), a.trys.pop();
                                    continue;
                            }
                            o = e.call(t, a);
                        } catch (t) {
                            (o = [6, t]), (n = 0);
                        } finally {
                            r = i = 0;
                        }
                    if (5 & o[0]) throw o[1];
                    return { value: o[0] ? o[1] : void 0, done: !0 };
                })([o, s]);
            };
        }
    }
    function vt(t) {
        var e = "function" == typeof Symbol && Symbol.iterator,
            r = e && t[e],
            n = 0;
        if (r) return r.call(t);
        if (t && "number" == typeof t.length)
            return {
                next: function () {
                    return t && n >= t.length && (t = void 0), { value: t && t[n++], done: !t };
                },
            };
        throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }
    function mt(t, e) {
        var r = "function" == typeof Symbol && t[Symbol.iterator];
        if (!r) return t;
        var n,
            i,
            o = r.call(t),
            a = [];
        try {
            for (; (void 0 === e || e-- > 0) && !(n = o.next()).done; ) a.push(n.value);
        } catch (t) {
            i = { error: t };
        } finally {
            try {
                n && !n.done && (r = o.return) && r.call(o);
            } finally {
                if (i) throw i.error;
            }
        }
        return a;
    }
    function yt(t, e, r) {
        if (r || 2 === arguments.length) for (var n, i = 0, o = e.length; i < o; i++) (!n && i in e) || (n || (n = Array.prototype.slice.call(e, 0, i)), (n[i] = e[i]));
        return t.concat(n || Array.prototype.slice.call(e));
    }
    var gt = (function () {
            function t() {}
            return (t.prototype.valueOf = function () {}), (t.prototype.liquidMethodMissing = function (t) {}), t;
        })(),
        wt = Object.prototype.toString,
        bt = String.prototype.toLowerCase;
    function _t(t) {
        return "string" == typeof t;
    }
    function St(t) {
        return "function" == typeof t;
    }
    function kt(t) {
        return _t((t = xt(t))) ? t : Ot(t) ? "" : String(t);
    }
    function xt(t) {
        return t instanceof gt ? t.valueOf() : t;
    }
    function Tt(t) {
        return "number" == typeof t;
    }
    function qt(t) {
        return t && St(t.toLiquid) ? qt(t.toLiquid()) : t;
    }
    function Ot(t) {
        return null == t;
    }
    function Et(t) {
        return "[object Array]" === wt.call(t);
    }
    function Lt(t, e) {
        for (var r in (t = t || {})) if (Object.hasOwnProperty.call(t, r) && !1 === e(t[r], r, t)) break;
        return t;
    }
    function Pt(t) {
        return t[t.length - 1];
    }
    function At(t) {
        var e = typeof t;
        return null !== t && ("object" === e || "function" === e);
    }
    function Ft(t, e, r) {
        void 0 === r && (r = 1);
        for (var n = [], i = t; i < e; i += r) n.push(i);
        return n;
    }
    function Nt(t, e, r) {
        return (
            void 0 === r && (r = " "),
            jt(t, e, r, function (t, e) {
                return e + t;
            })
        );
    }
    function jt(t, e, r, n) {
        for (var i = e - (t = String(t)).length; i-- > 0; ) t = n(t, r);
        return t;
    }
    function Ct(t) {
        return t;
    }
    function Rt(t) {
        return t.replace(/(\w?)([A-Z])/g, function (t, e, r) {
            return (e ? e + "_" : "") + r.toLowerCase();
        });
    }
    function Dt(t, e) {
        return null == t && null == e ? 0 : null == t ? 1 : null == e || (t = bt.call(t)) < (e = bt.call(e)) ? -1 : t > e ? 1 : 0;
    }
    var Vt = function (t, e, r, n) {
            (this.key = t), (this.value = e), (this.next = r), (this.prev = n);
        },
        Mt = (function () {
            function t(t, e) {
                void 0 === e && (e = 0),
                    (this.limit = t),
                    (this.size = e),
                    (this.cache = {}),
                    (this.head = new Vt("HEAD", null, null, null)),
                    (this.tail = new Vt("TAIL", null, null, null)),
                    (this.head.next = this.tail),
                    (this.tail.prev = this.head);
            }
            return (
                (t.prototype.write = function (t, e) {
                    if (this.cache[t]) this.cache[t].value = e;
                    else {
                        var r = new Vt(t, e, this.head.next, this.head);
                        (this.head.next.prev = r), (this.head.next = r), (this.cache[t] = r), this.size++, this.ensureLimit();
                    }
                }),
                (t.prototype.read = function (t) {
                    if (this.cache[t]) {
                        var e = this.cache[t].value;
                        return this.remove(t), this.write(t, e), e;
                    }
                }),
                (t.prototype.remove = function (t) {
                    var e = this.cache[t];
                    (e.prev.next = e.next), (e.next.prev = e.prev), delete this.cache[t], this.size--;
                }),
                (t.prototype.clear = function () {
                    (this.head.next = this.tail), (this.tail.prev = this.head), (this.size = 0), (this.cache = {});
                }),
                (t.prototype.ensureLimit = function () {
                    this.size > this.limit && this.remove(this.tail.prev.key);
                }),
                t
            );
        })();
    function It(t, e) {
        var r = document.createElement("base");
        r.href = t;
        var n = document.getElementsByTagName("head")[0];
        n.insertBefore(r, n.firstChild);
        var i = document.createElement("a");
        i.href = e;
        var o = i.href;
        return n.removeChild(r), o;
    }
    var Bt = Object.freeze({
        __proto__: null,
        resolve: function (t, e, r) {
            return (
                t.length && "/" !== Pt(t) && (t += "/"),
                It(t, e).replace(/^(\w+:\/\/[^/]+)(\/[^?]+)/, function (t, e, n) {
                    var i = n.split("/").pop();
                    return /\.\w+$/.test(i) ? t : e + n + r;
                })
            );
        },
        readFile: function (t) {
            return dt(this, void 0, void 0, function () {
                return ht(this, function (e) {
                    return [
                        2,
                        new Promise(function (e, r) {
                            var n = new XMLHttpRequest();
                            (n.onload = function () {
                                n.status >= 200 && n.status < 300 ? e(n.responseText) : r(new Error(n.statusText));
                            }),
                                (n.onerror = function () {
                                    r(new Error("An error occurred whilst receiving the response."));
                                }),
                                n.open("GET", t),
                                n.send();
                        }),
                    ];
                });
            });
        },
        readFileSync: function (t) {
            var e = new XMLHttpRequest();
            if ((e.open("GET", t, !1), e.send(), e.status < 200 || e.status >= 300)) throw new Error(e.statusText);
            return e.responseText;
        },
        exists: function (t) {
            return dt(this, void 0, void 0, function () {
                return ht(this, function (t) {
                    return [2, !0];
                });
            });
        },
        existsSync: function (t) {
            return !0;
        },
        dirname: function (t) {
            return It(t, ".");
        },
        sep: "/",
    });
    function zt(t) {
        return t && St(t.equals);
    }
    function Ht(t, e) {
        return !Wt(t, e);
    }
    function Wt(t, e) {
        return e.opts.jsTruthy ? !t : !1 === t || null == t;
    }
    var Ut = {
            "==": function (t, e) {
                return zt(t) ? t.equals(e) : zt(e) ? e.equals(t) : t === e;
            },
            "!=": function (t, e) {
                return zt(t) ? !t.equals(e) : zt(e) ? !e.equals(t) : t !== e;
            },
            ">": function (t, e) {
                return zt(t) ? t.gt(e) : zt(e) ? e.lt(t) : t > e;
            },
            "<": function (t, e) {
                return zt(t) ? t.lt(e) : zt(e) ? e.gt(t) : t < e;
            },
            ">=": function (t, e) {
                return zt(t) ? t.geq(e) : zt(e) ? e.leq(t) : t >= e;
            },
            "<=": function (t, e) {
                return zt(t) ? t.leq(e) : zt(e) ? e.geq(t) : t <= e;
            },
            contains: function (t, e) {
                return !(!t || !St(t.indexOf)) && t.indexOf(e) > -1;
            },
            and: function (t, e, r) {
                return Ht(t, r) && Ht(e, r);
            },
            or: function (t, e, r) {
                return Ht(t, r) || Ht(e, r);
            },
        },
        Jt = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            20,
            4,
            4,
            4,
            20,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            20,
            2,
            8,
            0,
            0,
            0,
            0,
            8,
            0,
            0,
            0,
            64,
            0,
            65,
            0,
            0,
            33,
            33,
            33,
            33,
            33,
            33,
            33,
            33,
            33,
            33,
            0,
            0,
            2,
            2,
            2,
            1,
            0,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            0,
            0,
            0,
            0,
            0,
        ];
    function Yt(t) {
        var e,
            r,
            n = {};
        try {
            for (var i = vt(Object.entries(t)), o = i.next(); !o.done; o = i.next()) {
                for (var a = mt(o.value, 2), s = a[0], c = a[1], u = n, l = 0; l < s.length; l++) {
                    var p = s[l];
                    (u[p] = u[p] || {}), l === s.length - 1 && 1 & Jt[s.charCodeAt(l)] && (u[p].needBoundary = !0), (u = u[p]);
                }
                (u.handler = c), (u.end = !0);
            }
        } catch (t) {
            e = { error: t };
        } finally {
            try {
                o && !o.done && (r = i.return) && r.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return n;
    }
    Jt[160] = Jt[5760] = Jt[6158] = Jt[8192] = Jt[8193] = Jt[8194] = Jt[8195] = Jt[8196] = Jt[8197] = Jt[8198] = Jt[8199] = Jt[8200] = Jt[8201] = Jt[8202] = Jt[8232] = Jt[8233] = Jt[8239] = Jt[8287] = Jt[12288] = 4;
    var Qt = {
        root: ["."],
        layouts: ["."],
        partials: ["."],
        relativeReference: !0,
        jekyllInclude: !1,
        cache: void 0,
        extname: "",
        fs: Bt,
        dynamicPartials: !0,
        jsTruthy: !1,
        trimTagRight: !1,
        trimTagLeft: !1,
        trimOutputRight: !1,
        trimOutputLeft: !1,
        greedy: !0,
        tagDelimiterLeft: "{%",
        tagDelimiterRight: "%}",
        outputDelimiterLeft: "{{",
        outputDelimiterRight: "}}",
        preserveTimezones: !1,
        strictFilters: !1,
        strictVariables: !1,
        ownPropertyOnly: !1,
        lenientIf: !1,
        globals: {},
        keepOutputType: !1,
        operators: Ut,
        operatorsTrie: Yt(Ut),
    };
    function $t(t) {
        var e = [];
        return Et(t) && (e = t), _t(t) && (e = [t]), e;
    }
    var Xt = (function (t) {
            function e(e, r) {
                var n = t.call(this, e.message) || this;
                return (n.originalError = e), (n.token = r), (n.context = ""), n;
            }
            return (
                pt(e, t),
                (e.prototype.update = function () {
                    var t = this.originalError;
                    (this.context = (function (t) {
                        var e = mt(t.getPosition(), 1)[0],
                            r = t.input.split("\n"),
                            n = Math.max(e - 2, 1),
                            i = Math.min(e + 3, r.length);
                        return Ft(n, i + 1)
                            .map(function (t) {
                                var n = t === e ? ">> " : "   ",
                                    o = Nt(String(t), String(i).length),
                                    a = r[t - 1];
                                return "".concat(n).concat(o, "| ").concat(a);
                            })
                            .join("\n");
                    })(this.token)),
                        (this.message = (function (t, e) {
                            e.file && (t += ", file:".concat(e.file));
                            var r = mt(e.getPosition(), 2),
                                n = r[0],
                                i = r[1];
                            return (t += ", line:".concat(n, ", col:").concat(i));
                        })(t.message, this.token)),
                        (this.stack = this.message + "\n" + this.context + "\n" + this.stack + "\nFrom " + t.stack);
                }),
                e
            );
        })(Error),
        Gt = (function (t) {
            function e(e, r) {
                var n = t.call(this, new Error(e), r) || this;
                return (n.name = "TokenizationError"), t.prototype.update.call(n), n;
            }
            return pt(e, t), e;
        })(Xt),
        Zt = (function (t) {
            function e(e, r) {
                var n = t.call(this, e, r) || this;
                return (n.name = "ParseError"), (n.message = e.message), t.prototype.update.call(n), n;
            }
            return pt(e, t), e;
        })(Xt),
        Kt = (function (t) {
            function e(e, r) {
                var n = t.call(this, e, r.token) || this;
                return (n.name = "RenderError"), (n.message = e.message), t.prototype.update.call(n), n;
            }
            return (
                pt(e, t),
                (e.is = function (t) {
                    return "RenderError" === t.name;
                }),
                e
            );
        })(Xt),
        te = (function (t) {
            function e(e, r) {
                var n = t.call(this, e, r) || this;
                return (n.name = "UndefinedVariableError"), (n.message = e.message), t.prototype.update.call(n), n;
            }
            return pt(e, t), e;
        })(Xt),
        ee = (function (t) {
            function e(e) {
                var r = t.call(this, "undefined variable: ".concat(e)) || this;
                return (r.name = "InternalUndefinedVariableError"), (r.variableName = e), r;
            }
            return pt(e, t), e;
        })(Error),
        re = (function (t) {
            function e(e) {
                var r = t.call(this, e) || this;
                return (r.name = "AssertionError"), (r.message = e + ""), r;
            }
            return pt(e, t), e;
        })(Error);
    var ne,
        ie = (function () {
            function t(t, e, r) {
                var n, i;
                void 0 === t && (t = {}),
                    void 0 === e && (e = Qt),
                    void 0 === r && (r = {}),
                    (this.scopes = [{}]),
                    (this.registers = {}),
                    (this.sync = !!r.sync),
                    (this.opts = e),
                    (this.globals = null !== (n = r.globals) && void 0 !== n ? n : e.globals),
                    (this.environments = t),
                    (this.strictVariables = null !== (i = r.strictVariables) && void 0 !== i ? i : this.opts.strictVariables);
            }
            return (
                (t.prototype.getRegister = function (t) {
                    return (this.registers[t] = this.registers[t] || {});
                }),
                (t.prototype.setRegister = function (t, e) {
                    return (this.registers[t] = e);
                }),
                (t.prototype.saveRegister = function () {
                    for (var t = this, e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
                    return e.map(function (e) {
                        return [e, t.getRegister(e)];
                    });
                }),
                (t.prototype.restoreRegister = function (t) {
                    var e = this;
                    return t.forEach(function (t) {
                        var r = mt(t, 2),
                            n = r[0],
                            i = r[1];
                        return e.setRegister(n, i);
                    });
                }),
                (t.prototype.getAll = function () {
                    return yt([this.globals, this.environments], mt(this.scopes), !1).reduce(function (t, e) {
                        return ft(t, e);
                    }, {});
                }),
                (t.prototype.get = function (t) {
                    var e = this.findScope(t[0]);
                    return this.getFromScope(e, t);
                }),
                (t.prototype.getFromScope = function (t, e) {
                    var r = this;
                    return (
                        _t(e) && (e = e.split(".")),
                        e.reduce(function (t, n, i) {
                            if (
                                ((t = (function (t, e, r) {
                                    if (Ot(t)) return t;
                                    var n = (function (t, e, r) {
                                        return r && !Object.hasOwnProperty.call(t, e) ? void 0 : t[e];
                                    })((t = qt(t)), e, r);
                                    if (St(n)) return n.call(t);
                                    if (t instanceof gt) return t.hasOwnProperty(e) ? t[e] : t.liquidMethodMissing(e);
                                    return "size" === e
                                        ? (function (t) {
                                              if (t.hasOwnProperty("size") || void 0 !== t.size) return t.size;
                                              if (Et(t) || _t(t)) return t.length;
                                              if ("object" == typeof t) return Object.keys(t).length;
                                          })(t)
                                        : "first" === e
                                        ? (function (t) {
                                              return Et(t) ? t[0] : t.first;
                                          })(t)
                                        : "last" === e
                                        ? (function (t) {
                                              return Et(t) ? t[t.length - 1] : t.last;
                                          })(t)
                                        : n;
                                })(t, n, r.opts.ownPropertyOnly)),
                                Ot(t) && r.strictVariables)
                            )
                                throw new ee(e.slice(0, i + 1).join("."));
                            return t;
                        }, t)
                    );
                }),
                (t.prototype.push = function (t) {
                    return this.scopes.push(t);
                }),
                (t.prototype.pop = function () {
                    return this.scopes.pop();
                }),
                (t.prototype.bottom = function () {
                    return this.scopes[0];
                }),
                (t.prototype.findScope = function (t) {
                    for (var e = this.scopes.length - 1; e >= 0; e--) {
                        var r = this.scopes[e];
                        if (t in r) return r;
                    }
                    return t in this.environments ? this.environments : this.globals;
                }),
                t
            );
        })();
    function oe(t, e) {
        if (!t) {
            var r = "function" == typeof e ? e() : e || "expect ".concat(t, " to be true");
            throw new re(r);
        }
    }
    !(function (t) {
        (t.Partials = "partials"), (t.Layouts = "layouts"), (t.Root = "root");
    })(ne || (ne = {}));
    var ae = (function () {
            function t(t) {
                if (((this.options = t), t.relativeReference)) {
                    var e = t.fs.sep;
                    oe(e, "`fs.sep` is required for relative reference");
                    var r = new RegExp(
                        ["." + e, ".." + e, "./", "../"]
                            .map(function (t) {
                                return t.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
                            })
                            .join("|")
                    );
                    this.shouldLoadRelative = function (t) {
                        return r.test(t);
                    };
                } else
                    this.shouldLoadRelative = function (t) {
                        return !1;
                    };
                this.contains =
                    this.options.fs.contains ||
                    function () {
                        return !0;
                    };
            }
            return (
                (t.prototype.lookup = function (t, e, r, n) {
                    var i, o, a, s, c, u, l, p, f;
                    return ht(this, function (d) {
                        switch (d.label) {
                            case 0:
                                (i = this.options.fs), (o = this.options[e]), (d.label = 1);
                            case 1:
                                d.trys.push([1, 8, 9, 10]), (a = vt(this.candidates(t, o, n, e !== ne.Root))), (s = a.next()), (d.label = 2);
                            case 2:
                                return s.done ? [3, 7] : ((c = s.value), r ? ((u = i.existsSync(c)), [3, 5]) : [3, 3]);
                            case 3:
                                return [4, i.exists(c)];
                            case 4:
                                (u = d.sent()), (d.label = 5);
                            case 5:
                                if (u) return [2, c];
                                d.label = 6;
                            case 6:
                                return (s = a.next()), [3, 2];
                            case 7:
                                return [3, 10];
                            case 8:
                                return (l = d.sent()), (p = { error: l }), [3, 10];
                            case 9:
                                try {
                                    s && !s.done && (f = a.return) && f.call(a);
                                } finally {
                                    if (p) throw p.error;
                                }
                                return [7];
                            case 10:
                                throw this.lookupError(t, o);
                        }
                    });
                }),
                (t.prototype.candidates = function (t, e, r, n) {
                    var i, o, a, s, c, u, l, p, f, d, h, v, m, y, g, w;
                    return ht(this, function (b) {
                        switch (b.label) {
                            case 0:
                                if (((i = this.options), (o = i.fs), (a = i.extname), !this.shouldLoadRelative(t) || !r)) return [3, 8];
                                (d = o.resolve(this.dirname(r), t, a)), (b.label = 1);
                            case 1:
                                b.trys.push([1, 6, 7, 8]), (s = vt(e)), (c = s.next()), (b.label = 2);
                            case 2:
                                return c.done ? [3, 5] : ((f = c.value), n && !this.contains(f, d) ? [3, 4] : [4, d]);
                            case 3:
                                return b.sent(), [3, 5];
                            case 4:
                                return (c = s.next()), [3, 2];
                            case 5:
                                return [3, 8];
                            case 6:
                                return (u = b.sent()), (m = { error: u }), [3, 8];
                            case 7:
                                try {
                                    c && !c.done && (y = s.return) && y.call(s);
                                } finally {
                                    if (m) throw m.error;
                                }
                                return [7];
                            case 8:
                                b.trys.push([8, 13, 14, 15]), (l = vt(e)), (p = l.next()), (b.label = 9);
                            case 9:
                                return p.done ? [3, 12] : ((f = p.value), (d = o.resolve(f, t, a)), n && !this.contains(f, d) ? [3, 11] : [4, d]);
                            case 10:
                                b.sent(), (b.label = 11);
                            case 11:
                                return (p = l.next()), [3, 9];
                            case 12:
                                return [3, 15];
                            case 13:
                                return (h = b.sent()), (g = { error: h }), [3, 15];
                            case 14:
                                try {
                                    p && !p.done && (w = l.return) && w.call(l);
                                } finally {
                                    if (g) throw g.error;
                                }
                                return [7];
                            case 15:
                                return void 0 === o.fallback || void 0 === (v = o.fallback(t)) ? [3, 17] : [4, v];
                            case 16:
                                b.sent(), (b.label = 17);
                            case 17:
                                return [2];
                        }
                    });
                }),
                (t.prototype.dirname = function (t) {
                    var e = this.options.fs;
                    return oe(e.dirname, "`fs.dirname` is required for relative reference"), e.dirname(t);
                }),
                (t.prototype.lookupError = function (t, e) {
                    var r = new Error("ENOENT");
                    return (r.message = 'ENOENT: Failed to lookup "'.concat(t, '" in "').concat(e, '"')), (r.code = "ENOENT"), r;
                }),
                t
            );
        })(),
        se = (function () {
            function t() {
                this.buffer = "";
            }
            return (
                (t.prototype.write = function (t) {
                    this.buffer += kt(t);
                }),
                t
            );
        })(),
        ce = function () {
            throw ((this.buffer = ""), (this.stream = null), new Error("streaming not supported in browser"));
        };
    function ue(t) {
        var e = {
            then: function (e) {
                return e(t);
            },
            catch: function () {
                return e;
            },
        };
        return e;
    }
    function le(t) {
        var e = {
            then: function (r, n) {
                return n ? n(t) : e;
            },
            catch: function (e) {
                return e(t);
            },
        };
        return e;
    }
    function pe(t) {
        return (function (t) {
            return t && St(t.then);
        })(t)
            ? t
            : (function (t) {
                  return t && St(t.next) && St(t.throw) && St(t.return);
              })(t)
            ? (function e(r) {
                  var n;
                  try {
                      n = t.next(r);
                  } catch (t) {
                      return le(t);
                  }
                  return n.done
                      ? ue(n.value)
                      : pe(n.value).then(e, function (r) {
                            var n;
                            try {
                                n = t.throw(r);
                            } catch (t) {
                                return le(t);
                            }
                            return n.done ? ue(n.value) : e(n.value);
                        });
              })()
            : ue(t);
    }
    function fe(t) {
        return Promise.resolve(pe(t));
    }
    function de(t) {
        var e;
        return (
            pe(t)
                .then(function (t) {
                    return ue((e = t));
                })
                .catch(function (t) {
                    throw t;
                }),
            e
        );
    }
    var he,
        ve = (function () {
            function t() {
                this.buffer = "";
            }
            return (
                (t.prototype.write = function (t) {
                    "string" != typeof (t = xt(t)) && "" === this.buffer ? (this.buffer = t) : (this.buffer = kt(this.buffer) + kt(t));
                }),
                t
            );
        })(),
        me = (function () {
            function t() {}
            return (
                (t.prototype.renderTemplatesToNodeStream = function (t, e) {
                    var r = this,
                        n = new ce();
                    return (
                        Promise.resolve()
                            .then(function () {
                                return pe(r.renderTemplates(t, e, n));
                            })
                            .then(
                                function () {
                                    return n.end();
                                },
                                function (t) {
                                    return n.error(t);
                                }
                            ),
                        n.stream
                    );
                }),
                (t.prototype.renderTemplates = function (t, e, r) {
                    var n, i, o, a, s, c, u, l;
                    return ht(this, function (p) {
                        switch (p.label) {
                            case 0:
                                r || (r = e.opts.keepOutputType ? new ve() : new se()), (p.label = 1);
                            case 1:
                                p.trys.push([1, 8, 9, 10]), (n = vt(t)), (i = n.next()), (p.label = 2);
                            case 2:
                                if (i.done) return [3, 7];
                                (o = i.value), (p.label = 3);
                            case 3:
                                return p.trys.push([3, 5, , 6]), [4, o.render(e, r)];
                            case 4:
                                return (a = p.sent()) && r.write(a), r.break || r.continue ? [3, 7] : [3, 6];
                            case 5:
                                throw ((s = p.sent()), Kt.is(s) ? s : new Kt(s, o));
                            case 6:
                                return (i = n.next()), [3, 2];
                            case 7:
                                return [3, 10];
                            case 8:
                                return (c = p.sent()), (u = { error: c }), [3, 10];
                            case 9:
                                try {
                                    i && !i.done && (l = n.return) && l.call(n);
                                } finally {
                                    if (u) throw u.error;
                                }
                                return [7];
                            case 10:
                                return [2, r.buffer];
                        }
                    });
                }),
                t
            );
        })();
    function ye(t) {
        return !!(Ee(t) & he.Delimited);
    }
    function ge(t) {
        return Ee(t) === he.Operator;
    }
    function we(t) {
        return Ee(t) === he.HTML;
    }
    function be(t) {
        return Ee(t) === he.Output;
    }
    function _e(t) {
        return Ee(t) === he.Tag;
    }
    function Se(t) {
        return Ee(t) === he.Quoted;
    }
    function ke(t) {
        return Ee(t) === he.Literal;
    }
    function xe(t) {
        return Ee(t) === he.Number;
    }
    function Te(t) {
        return Ee(t) === he.PropertyAccess;
    }
    function qe(t) {
        return Ee(t) === he.Word;
    }
    function Oe(t) {
        return Ee(t) === he.Range;
    }
    function Ee(t) {
        return t ? t.kind : -1;
    }
    !(function (t) {
        (t[(t.Number = 1)] = "Number"),
            (t[(t.Literal = 2)] = "Literal"),
            (t[(t.Tag = 4)] = "Tag"),
            (t[(t.Output = 8)] = "Output"),
            (t[(t.HTML = 16)] = "HTML"),
            (t[(t.Filter = 32)] = "Filter"),
            (t[(t.Hash = 64)] = "Hash"),
            (t[(t.PropertyAccess = 128)] = "PropertyAccess"),
            (t[(t.Word = 256)] = "Word"),
            (t[(t.Range = 512)] = "Range"),
            (t[(t.Quoted = 1024)] = "Quoted"),
            (t[(t.Operator = 2048)] = "Operator"),
            (t[(t.Delimited = 12)] = "Delimited");
    })(he || (he = {}));
    var Le = (function () {
            function t(t, e) {
                (this.handlers = {}), (this.stopRequested = !1), (this.tokens = t), (this.parseToken = e);
            }
            return (
                (t.prototype.on = function (t, e) {
                    return (this.handlers[t] = e), this;
                }),
                (t.prototype.trigger = function (t, e) {
                    var r = this.handlers[t];
                    return !!r && (r.call(this, e), !0);
                }),
                (t.prototype.start = function () {
                    var t;
                    for (this.trigger("start"); !this.stopRequested && (t = this.tokens.shift()); )
                        if (!(this.trigger("token", t) || (_e(t) && this.trigger("tag:".concat(t.name), t)))) {
                            var e = this.parseToken(t, this.tokens);
                            this.trigger("template", e);
                        }
                    return this.stopRequested || this.trigger("end"), this;
                }),
                (t.prototype.stop = function () {
                    return (this.stopRequested = !0), this;
                }),
                t
            );
        })(),
        Pe = function (t) {
            this.token = t;
        },
        Ae = (function (t) {
            function e() {
                return (null !== t && t.apply(this, arguments)) || this;
            }
            return (
                pt(e, t),
                (e.prototype.equals = function (t) {
                    return Ot(xt(t));
                }),
                (e.prototype.gt = function () {
                    return !1;
                }),
                (e.prototype.geq = function () {
                    return !1;
                }),
                (e.prototype.lt = function () {
                    return !1;
                }),
                (e.prototype.leq = function () {
                    return !1;
                }),
                (e.prototype.valueOf = function () {
                    return null;
                }),
                e
            );
        })(gt),
        Fe = (function (t) {
            function e() {
                return (null !== t && t.apply(this, arguments)) || this;
            }
            return (
                pt(e, t),
                (e.prototype.equals = function (t) {
                    return !(t instanceof e) && (_t((t = xt(t))) || Et(t) ? 0 === t.length : !!At(t) && 0 === Object.keys(t).length);
                }),
                (e.prototype.gt = function () {
                    return !1;
                }),
                (e.prototype.geq = function () {
                    return !1;
                }),
                (e.prototype.lt = function () {
                    return !1;
                }),
                (e.prototype.leq = function () {
                    return !1;
                }),
                (e.prototype.valueOf = function () {
                    return "";
                }),
                e
            );
        })(gt),
        Ne = (function (t) {
            function e() {
                return (null !== t && t.apply(this, arguments)) || this;
            }
            return (
                pt(e, t),
                (e.prototype.equals = function (e) {
                    return !1 === e || !!Ot(xt(e)) || (_t(e) ? /^\s*$/.test(e) : t.prototype.equals.call(this, e));
                }),
                e
            );
        })(Fe),
        je = new Ae(),
        Ce = { true: !0, false: !1, nil: je, null: je, empty: new Fe(), blank: new Ne() },
        Re = /[\da-fA-F]/,
        De = /[0-7]/,
        Ve = { b: "\b", f: "\f", n: "\n", r: "\r", t: "\t", v: "\v" };
    function Me(t) {
        var e = t.charCodeAt(0);
        return e >= 97 ? e - 87 : e >= 65 ? e - 55 : e - 48;
    }
    function Ie(t) {
        for (var e = "", r = 1; r < t.length - 1; r++)
            if ("\\" === t[r])
                if (void 0 !== Ve[t[r + 1]]) e += Ve[t[++r]];
                else if ("u" === t[r + 1]) {
                    for (var n = 0, i = r + 2; i <= r + 5 && Re.test(t[i]); ) n = 16 * n + Me(t[i++]);
                    (r = i - 1), (e += String.fromCharCode(n));
                } else if (De.test(t[r + 1])) {
                    for (i = r + 1, n = 0; i <= r + 3 && De.test(t[i]); ) n = 8 * n + Me(t[i++]);
                    (r = i - 1), (e += String.fromCharCode(n));
                } else e += t[++r];
            else e += t[r];
        return e;
    }
    var Be = (function () {
        function t(t) {
            this.postfix = yt(
                [],
                mt(
                    (function (t) {
                        var e, r, n, i, o, a, s;
                        return ht(this, function (c) {
                            switch (c.label) {
                                case 0:
                                    (e = []), (c.label = 1);
                                case 1:
                                    c.trys.push([1, 10, 11, 12]), (r = vt(t)), (n = r.next()), (c.label = 2);
                                case 2:
                                    if (n.done) return [3, 9];
                                    if (!ge((i = n.value))) return [3, 6];
                                    c.label = 3;
                                case 3:
                                    return e.length && e[e.length - 1].getPrecedence() > i.getPrecedence() ? [4, e.pop()] : [3, 5];
                                case 4:
                                    return c.sent(), [3, 3];
                                case 5:
                                    return e.push(i), [3, 8];
                                case 6:
                                    return [4, i];
                                case 7:
                                    c.sent(), (c.label = 8);
                                case 8:
                                    return (n = r.next()), [3, 2];
                                case 9:
                                    return [3, 12];
                                case 10:
                                    return (o = c.sent()), (a = { error: o }), [3, 12];
                                case 11:
                                    try {
                                        n && !n.done && (s = r.return) && s.call(r);
                                    } finally {
                                        if (a) throw a.error;
                                    }
                                    return [7];
                                case 12:
                                    return e.length ? [4, e.pop()] : [3, 14];
                                case 13:
                                    return c.sent(), [3, 12];
                                case 14:
                                    return [2];
                            }
                        });
                    })(t)
                ),
                !1
            );
        }
        return (
            (t.prototype.evaluate = function (t, e) {
                var r, n, i, o, a, s, c, u, l, p, f, d;
                return ht(this, function (h) {
                    switch (h.label) {
                        case 0:
                            oe(t, "unable to evaluate: context not defined"), (r = []), (h.label = 1);
                        case 1:
                            h.trys.push([1, 9, 10, 11]), (n = vt(this.postfix)), (i = n.next()), (h.label = 2);
                        case 2:
                            return i.done ? [3, 8] : ge((o = i.value)) ? [4, r.pop()] : [3, 5];
                        case 3:
                            return (a = h.sent()), [4, r.pop()];
                        case 4:
                            return (
                                (s = h.sent()),
                                (c = (function (t, e, r, n, i) {
                                    return (0, t[e.operator])(r, n, i);
                                })(t.opts.operators, o, s, a, t)),
                                r.push(c),
                                [3, 7]
                            );
                        case 5:
                            return (l = (u = r).push), [4, ze(o, t, e && 1 === this.postfix.length)];
                        case 6:
                            l.apply(u, [h.sent()]), (h.label = 7);
                        case 7:
                            return (i = n.next()), [3, 2];
                        case 8:
                            return [3, 11];
                        case 9:
                            return (p = h.sent()), (f = { error: p }), [3, 11];
                        case 10:
                            try {
                                i && !i.done && (d = n.return) && d.call(n);
                            } finally {
                                if (f) throw f.error;
                            }
                            return [7];
                        case 11:
                            return [2, r[0]];
                    }
                });
            }),
            t
        );
    })();
    function ze(t, e, r) {
        return (
            void 0 === r && (r = !1),
            Te(t)
                ? (function (t, e, r) {
                      var n = t.props.map(function (t) {
                          return ze(t, e, !1);
                      });
                      try {
                          return e.get(yt([t.propertyName], mt(n), !1));
                      } catch (e) {
                          if (r && "InternalUndefinedVariableError" === e.name) return null;
                          throw new te(e, t);
                      }
                  })(t, e, r)
                : Oe(t)
                ? (function (t, e) {
                      var r = ze(t.lhs, e),
                          n = ze(t.rhs, e);
                      return Ft(+r, +n + 1);
                  })(t, e)
                : ke(t)
                ? (function (t) {
                      return Ce[t.literal];
                  })(t)
                : xe(t)
                ? (function (t) {
                      var e = t.whole.content + "." + (t.decimal ? t.decimal.content : "");
                      return Number(e);
                  })(t)
                : qe(t)
                ? t.getText()
                : Se(t)
                ? He(t)
                : void 0
        );
    }
    function He(t) {
        return Ie(t.getText());
    }
    var We = (function () {
            function t(t, e, r, n, i) {
                (this.kind = t), (this.input = e), (this.begin = r), (this.end = n), (this.file = i);
            }
            return (
                (t.prototype.getText = function () {
                    return this.input.slice(this.begin, this.end);
                }),
                (t.prototype.getPosition = function () {
                    for (var t = mt([1, 1], 2), e = t[0], r = t[1], n = 0; n < this.begin; n++) "\n" === this.input[n] ? (e++, (r = 1)) : r++;
                    return [e, r];
                }),
                (t.prototype.size = function () {
                    return this.end - this.begin;
                }),
                t
            );
        })(),
        Ue = (function (t) {
            function e(e, r, n, i, o, a, s, c) {
                var u = t.call(this, e, n, i, o, c) || this;
                (u.trimLeft = !1), (u.trimRight = !1), (u.content = u.getText());
                var l = "-" === r[0],
                    p = "-" === Pt(r);
                return (u.content = r.slice(l ? 1 : 0, p ? -1 : r.length).trim()), (u.trimLeft = l || a), (u.trimRight = p || s), u;
            }
            return pt(e, t), e;
        })(We);
    function Je(t, e) {
        if (t && we(t)) for (var r = e ? 4 : 16; Jt[t.input.charCodeAt(t.end - 1 - t.trimRight)] & r; ) t.trimRight++;
    }
    function Ye(t, e) {
        if (t && we(t)) {
            for (var r = e ? 4 : 16; Jt[t.input.charCodeAt(t.begin + t.trimLeft)] & r; ) t.trimLeft++;
            "\n" === t.input.charAt(t.begin + t.trimLeft) && t.trimLeft++;
        }
    }
    var Qe = (function (t) {
            function e(e, r) {
                var n = t.call(this, he.Number, e.input, e.begin, r ? r.end : e.end, e.file) || this;
                return (n.whole = e), (n.decimal = r), n;
            }
            return pt(e, t), e;
        })(We),
        $e = (function (t) {
            function e(e, r, n, i) {
                var o = t.call(this, he.Word, e, r, n, i) || this;
                return (o.input = e), (o.begin = r), (o.end = n), (o.file = i), (o.content = o.getText()), o;
            }
            return (
                pt(e, t),
                (e.prototype.isNumber = function (t) {
                    void 0 === t && (t = !1);
                    for (var e = t && 64 & Jt[this.input.charCodeAt(this.begin)] ? this.begin + 1 : this.begin; e < this.end; e++) if (!(32 & Jt[this.input.charCodeAt(e)])) return !1;
                    return !0;
                }),
                e
            );
        })(We),
        Xe = (function (t) {
            function e(e, r, n, i) {
                var o = t.call(this, he.Literal, e, r, n, i) || this;
                return (o.input = e), (o.begin = r), (o.end = n), (o.file = i), (o.literal = o.getText()), o;
            }
            return pt(e, t), e;
        })(We),
        Ge = { "==": 1, "!=": 1, ">": 1, "<": 1, ">=": 1, "<=": 1, contains: 1, and: 0, or: 0 },
        Ze = (function (t) {
            function e(e, r, n, i) {
                var o = t.call(this, he.Operator, e, r, n, i) || this;
                return (o.input = e), (o.begin = r), (o.end = n), (o.file = i), (o.operator = o.getText()), o;
            }
            return (
                pt(e, t),
                (e.prototype.getPrecedence = function () {
                    var t = this.getText();
                    return t in Ge ? Ge[t] : 1;
                }),
                e
            );
        })(We),
        Ke = (function (t) {
            function e(e, r, n) {
                var i = t.call(this, he.PropertyAccess, e.input, e.begin, n, e.file) || this;
                return (i.variable = e), (i.props = r), (i.propertyName = i.variable instanceof $e ? i.variable.getText() : Ie(i.variable.getText())), i;
            }
            return pt(e, t), e;
        })(We),
        tr = (function (t) {
            function e(e, r, n, i, o, a) {
                var s = t.call(this, he.Filter, n, i, o, a) || this;
                return (s.name = e), (s.args = r), s;
            }
            return pt(e, t), e;
        })(We),
        er = (function (t) {
            function e(e, r, n, i, o, a) {
                var s = t.call(this, he.Hash, e, r, n, a) || this;
                return (s.input = e), (s.begin = r), (s.end = n), (s.name = i), (s.value = o), (s.file = a), s;
            }
            return pt(e, t), e;
        })(We),
        rr = (function (t) {
            function e(e, r, n, i) {
                var o = t.call(this, he.Quoted, e, r, n, i) || this;
                return (o.input = e), (o.begin = r), (o.end = n), (o.file = i), o;
            }
            return pt(e, t), e;
        })(We),
        nr = (function (t) {
            function e(e, r, n, i) {
                var o = t.call(this, he.HTML, e, r, n, i) || this;
                return (o.input = e), (o.begin = r), (o.end = n), (o.file = i), (o.trimLeft = 0), (o.trimRight = 0), o;
            }
            return (
                pt(e, t),
                (e.prototype.getContent = function () {
                    return this.input.slice(this.begin + this.trimLeft, this.end - this.trimRight);
                }),
                e
            );
        })(We),
        ir = (function (t) {
            function e(e, r, n, i, o, a) {
                var s = t.call(this, he.Range, e, r, n, a) || this;
                return (s.input = e), (s.begin = r), (s.end = n), (s.lhs = i), (s.rhs = o), (s.file = a), s;
            }
            return pt(e, t), e;
        })(We),
        or = (function (t) {
            function e(e, r, n, i, o) {
                var a = i.trimOutputLeft,
                    s = i.trimOutputRight,
                    c = i.outputDelimiterLeft,
                    u = i.outputDelimiterRight,
                    l = e.slice(r + c.length, n - u.length);
                return t.call(this, he.Output, l, e, r, n, a, s, o) || this;
            }
            return pt(e, t), e;
        })(Ue);
    var ar = (function (t) {
            function e(e, r, n, i, o) {
                var a = this,
                    s = e.slice(r, n);
                if (((a = t.call(this, he.Tag, s, e, r, n, !1, !1, o) || this), /\S/.test(s))) {
                    var c = new sr(a.content, i.operatorsTrie);
                    if (((a.name = c.readIdentifier().getText()), !a.name)) throw new Gt("illegal liquid tag syntax", a);
                    c.skipBlank(), (a.args = c.remaining());
                } else (a.name = ""), (a.args = "");
                return a;
            }
            return pt(e, t), e;
        })(Ue),
        sr = (function () {
            function t(t, e, r) {
                void 0 === r && (r = ""), (this.input = t), (this.trie = e), (this.file = r), (this.p = 0), (this.rawBeginAt = -1), (this.N = t.length);
            }
            return (
                (t.prototype.readExpression = function () {
                    return new Be(this.readExpressionTokens());
                }),
                (t.prototype.readExpressionTokens = function () {
                    var t, e, r;
                    return ht(this, function (n) {
                        switch (n.label) {
                            case 0:
                                return (t = this.readValue()) ? [4, t] : [2];
                            case 1:
                                n.sent(), (n.label = 2);
                            case 2:
                                return this.p < this.N ? ((e = this.readOperator()) && (r = this.readValue()) ? [4, e] : [2]) : [3, 5];
                            case 3:
                                return n.sent(), [4, r];
                            case 4:
                                return n.sent(), [3, 2];
                            case 5:
                                return [2];
                        }
                    });
                }),
                (t.prototype.readOperator = function () {
                    this.skipBlank();
                    var t = (function (t, e, r, n) {
                        void 0 === n && (n = t.length);
                        for (var i, o = r, a = e; o[t[a]] && a < n; ) (o = o[t[a++]]).end && (i = o);
                        return i ? (i.needBoundary && 1 & Jt[t.charCodeAt(a)] ? -1 : a) : -1;
                    })(this.input, this.p, this.trie);
                    if (-1 !== t) return new Ze(this.input, this.p, (this.p = t), this.file);
                }),
                (t.prototype.readFilters = function () {
                    for (var t = []; ; ) {
                        var e = this.readFilter();
                        if (!e) return t;
                        t.push(e);
                    }
                }),
                (t.prototype.readFilter = function () {
                    var t = this;
                    if ((this.skipBlank(), this.end())) return null;
                    oe("|" === this.peek(), function () {
                        return "unexpected token at ".concat(t.snapshot());
                    }),
                        this.p++;
                    var e = this.p,
                        r = this.readIdentifier();
                    if (!r.size()) return null;
                    var n = [];
                    if ((this.skipBlank(), ":" === this.peek()))
                        do {
                            ++this.p;
                            var i = this.readFilterArg();
                            for (i && n.push(i); this.p < this.N && "," !== this.peek() && "|" !== this.peek(); ) ++this.p;
                        } while ("," === this.peek());
                    return new tr(r.getText(), n, this.input, e, this.p, this.file);
                }),
                (t.prototype.readFilterArg = function () {
                    var t = this.readValue();
                    if (t) {
                        if ((this.skipBlank(), ":" !== this.peek())) return t;
                        ++this.p;
                        var e = this.readValue();
                        return [t.getText(), e];
                    }
                }),
                (t.prototype.readTopLevelTokens = function (t) {
                    void 0 === t && (t = Qt);
                    for (var e = []; this.p < this.N; ) {
                        var r = this.readTopLevelToken(t);
                        e.push(r);
                    }
                    return (
                        (function (t, e) {
                            for (var r = !1, n = 0; n < t.length; n++) {
                                var i = t[n];
                                ye(i) && (!r && i.trimLeft && Je(t[n - 1], e.greedy), _e(i) && ("raw" === i.name ? (r = !0) : "endraw" === i.name && (r = !1)), !r && i.trimRight && Ye(t[n + 1], e.greedy));
                            }
                        })(e, t),
                        e
                    );
                }),
                (t.prototype.readTopLevelToken = function (t) {
                    var e = t.tagDelimiterLeft,
                        r = t.outputDelimiterLeft;
                    return this.rawBeginAt > -1 ? this.readEndrawOrRawContent(t) : this.match(e) ? this.readTagToken(t) : this.match(r) ? this.readOutputToken(t) : this.readHTMLToken([e, r]);
                }),
                (t.prototype.readHTMLToken = function (t) {
                    for (
                        var e = this, r = this.p;
                        this.p < this.N &&
                        !t.some(function (t) {
                            return e.match(t);
                        });

                    )
                        ++this.p;
                    return new nr(this.input, r, this.p, this.file);
                }),
                (t.prototype.readTagToken = function (t) {
                    void 0 === t && (t = Qt);
                    var e = this.file,
                        r = this.input,
                        n = this.p;
                    if (-1 === this.readToDelimiter(t.tagDelimiterRight)) throw this.mkError("tag ".concat(this.snapshot(n), " not closed"), n);
                    var i = new cr(r, n, this.p, t, e);
                    return "raw" === i.name && (this.rawBeginAt = n), i;
                }),
                (t.prototype.readToDelimiter = function (t) {
                    for (; this.p < this.N; )
                        if (8 & this.peekType()) this.readQuoted();
                        else if ((++this.p, this.rmatch(t))) return this.p;
                    return -1;
                }),
                (t.prototype.readOutputToken = function (t) {
                    void 0 === t && (t = Qt);
                    var e = this.file,
                        r = this.input,
                        n = t.outputDelimiterRight,
                        i = this.p;
                    if (-1 === this.readToDelimiter(n)) throw this.mkError("output ".concat(this.snapshot(i), " not closed"), i);
                    return new or(r, i, this.p, t, e);
                }),
                (t.prototype.readEndrawOrRawContent = function (t) {
                    for (var e = t.tagDelimiterLeft, r = t.tagDelimiterRight, n = this.p, i = this.readTo(e) - e.length; this.p < this.N; )
                        if ("endraw" === this.readIdentifier().getText())
                            for (; this.p <= this.N; ) {
                                if (this.rmatch(r)) {
                                    var o = this.p;
                                    return n === i ? ((this.rawBeginAt = -1), new cr(this.input, n, o, t, this.file)) : ((this.p = i), new nr(this.input, n, i, this.file));
                                }
                                if (this.rmatch(e)) break;
                                this.p++;
                            }
                        else i = this.readTo(e) - e.length;
                    throw this.mkError("raw ".concat(this.snapshot(this.rawBeginAt), " not closed"), n);
                }),
                (t.prototype.readLiquidTagTokens = function (t) {
                    void 0 === t && (t = Qt);
                    for (var e = []; this.p < this.N; ) {
                        var r = this.readLiquidTagToken(t);
                        r.name && e.push(r);
                    }
                    return e;
                }),
                (t.prototype.readLiquidTagToken = function (t) {
                    var e = this.file,
                        r = this.input,
                        n = this.p,
                        i = this.N;
                    return -1 !== this.readToDelimiter("\n") && (i = this.p), new ar(r, n, i, t, e);
                }),
                (t.prototype.mkError = function (t, e) {
                    return new Gt(t, new $e(this.input, e, this.N, this.file));
                }),
                (t.prototype.snapshot = function (t) {
                    return void 0 === t && (t = this.p), JSON.stringify(((e = this.input.slice(t)), (r = 16), e.length > r ? e.substr(0, r - 3) + "..." : e));
                    var e, r;
                }),
                (t.prototype.readWord = function () {
                    return console.warn("Tokenizer#readWord() will be removed, use #readIdentifier instead"), this.readIdentifier();
                }),
                (t.prototype.readIdentifier = function () {
                    this.skipBlank();
                    for (var t = this.p; 1 & this.peekType(); ) ++this.p;
                    return new $e(this.input, t, this.p, this.file);
                }),
                (t.prototype.readHashes = function (t) {
                    for (var e = []; ; ) {
                        var r = this.readHash(t);
                        if (!r) return e;
                        e.push(r);
                    }
                }),
                (t.prototype.readHash = function (t) {
                    this.skipBlank(), "," === this.peek() && ++this.p;
                    var e = this.p,
                        r = this.readIdentifier();
                    if (r.size()) {
                        var n;
                        this.skipBlank();
                        var i = t ? "=" : ":";
                        return this.peek() === i && (++this.p, (n = this.readValue())), new er(this.input, e, this.p, r, n, this.file);
                    }
                }),
                (t.prototype.remaining = function () {
                    return this.input.slice(this.p);
                }),
                (t.prototype.advance = function (t) {
                    void 0 === t && (t = 1), (this.p += t);
                }),
                (t.prototype.end = function () {
                    return this.p >= this.N;
                }),
                (t.prototype.readTo = function (t) {
                    for (; this.p < this.N; ) if ((++this.p, this.rmatch(t))) return this.p;
                    return -1;
                }),
                (t.prototype.readValue = function () {
                    var t = this.readQuoted() || this.readRange();
                    if (t) return t;
                    if ("[" === this.peek()) {
                        if ((this.p++, !(i = this.readQuoted()))) return;
                        if ("]" !== this.peek()) return;
                        return this.p++, new Ke(i, [], this.p);
                    }
                    var e = this.readIdentifier();
                    if (e.size()) {
                        for (var r = e.isNumber(!0), n = []; ; )
                            if ("[" === this.peek()) {
                                (r = !1), this.p++;
                                var i = this.readValue() || new $e(this.input, this.p, this.p, this.file);
                                this.readTo("]"), n.push(i);
                            } else {
                                if ("." !== this.peek() || "." === this.peek(1)) break;
                                if ((this.p++, !(i = this.readIdentifier()).size())) break;
                                i.isNumber() || (r = !1), n.push(i);
                            }
                        return !n.length && Ce.hasOwnProperty(e.content) ? new Xe(this.input, e.begin, e.end, this.file) : r ? new Qe(e, n[0]) : new Ke(e, n, this.p);
                    }
                }),
                (t.prototype.readRange = function () {
                    this.skipBlank();
                    var t = this.p;
                    if ("(" === this.peek()) {
                        ++this.p;
                        var e = this.readValueOrThrow();
                        this.p += 2;
                        var r = this.readValueOrThrow();
                        return ++this.p, new ir(this.input, t, this.p, e, r, this.file);
                    }
                }),
                (t.prototype.readValueOrThrow = function () {
                    var t = this,
                        e = this.readValue();
                    return (
                        oe(e, function () {
                            return "unexpected token ".concat(t.snapshot(), ", value expected");
                        }),
                        e
                    );
                }),
                (t.prototype.readQuoted = function () {
                    this.skipBlank();
                    var t = this.p;
                    if (8 & this.peekType()) {
                        ++this.p;
                        for (var e = !1; this.p < this.N && (++this.p, this.input[this.p - 1] !== this.input[t] || e); ) e ? (e = !1) : "\\" === this.input[this.p - 1] && (e = !0);
                        return new rr(this.input, t, this.p, this.file);
                    }
                }),
                (t.prototype.readFileNameTemplate = function (t) {
                    var e, r, n;
                    return ht(this, function (i) {
                        switch (i.label) {
                            case 0:
                                (e = t.outputDelimiterLeft), (r = [",", " ", e]), (n = new Set(r)), (i.label = 1);
                            case 1:
                                return this.p < this.N && !n.has(this.peek()) ? [4, this.match(e) ? this.readOutputToken(t) : this.readHTMLToken(r)] : [3, 3];
                            case 2:
                                return i.sent(), [3, 1];
                            case 3:
                                return [2];
                        }
                    });
                }),
                (t.prototype.match = function (t) {
                    for (var e = 0; e < t.length; e++) if (t[e] !== this.input[this.p + e]) return !1;
                    return !0;
                }),
                (t.prototype.rmatch = function (t) {
                    for (var e = 0; e < t.length; e++) if (t[t.length - 1 - e] !== this.input[this.p - 1 - e]) return !1;
                    return !0;
                }),
                (t.prototype.peekType = function (t) {
                    return void 0 === t && (t = 0), Jt[this.input.charCodeAt(this.p + t)];
                }),
                (t.prototype.peek = function (t) {
                    return void 0 === t && (t = 0), this.input[this.p + t];
                }),
                (t.prototype.skipBlank = function () {
                    for (; 4 & this.peekType(); ) ++this.p;
                }),
                t
            );
        })(),
        cr = (function (t) {
            function e(e, r, n, i, o) {
                var a = this,
                    s = i.trimTagLeft,
                    c = i.trimTagRight,
                    u = i.tagDelimiterLeft,
                    l = i.tagDelimiterRight,
                    p = e.slice(r + u.length, n - l.length);
                a = t.call(this, he.Tag, p, e, r, n, s, c, o) || this;
                var f = new sr(a.content, i.operatorsTrie);
                if (((a.name = f.readIdentifier().getText()), !a.name)) throw new Gt("illegal tag syntax", a);
                return f.skipBlank(), (a.args = f.remaining()), a;
            }
            return pt(e, t), e;
        })(Ue),
        ur = (function () {
            function t(t, e) {
                var r, n;
                this.hash = {};
                var i = new sr(t, {});
                try {
                    for (var o = vt(i.readHashes(e)), a = o.next(); !a.done; a = o.next()) {
                        var s = a.value;
                        this.hash[s.name.content] = s.value;
                    }
                } catch (t) {
                    r = { error: t };
                } finally {
                    try {
                        a && !a.done && (n = o.return) && n.call(o);
                    } finally {
                        if (r) throw r.error;
                    }
                }
            }
            return (
                (t.prototype.render = function (t) {
                    var e, r, n, i, o, a, s, c, u, l;
                    return ht(this, function (p) {
                        switch (p.label) {
                            case 0:
                                (e = {}), (p.label = 1);
                            case 1:
                                p.trys.push([1, 8, 9, 10]), (r = vt(Object.keys(this.hash))), (n = r.next()), (p.label = 2);
                            case 2:
                                return n.done ? [3, 7] : ((i = n.value), (o = e), (a = i), void 0 !== this.hash[i] ? [3, 3] : ((s = !0), [3, 5]));
                            case 3:
                                return [4, ze(this.hash[i], t)];
                            case 4:
                                (s = p.sent()), (p.label = 5);
                            case 5:
                                (o[a] = s), (p.label = 6);
                            case 6:
                                return (n = r.next()), [3, 2];
                            case 7:
                                return [3, 10];
                            case 8:
                                return (c = p.sent()), (u = { error: c }), [3, 10];
                            case 9:
                                try {
                                    n && !n.done && (l = r.return) && l.call(r);
                                } finally {
                                    if (u) throw u.error;
                                }
                                return [7];
                            case 10:
                                return [2, e];
                        }
                    });
                }),
                t
            );
        })();
    var lr = (function () {
            function t(t, e, r, n) {
                (this.name = t), (this.impl = e || Ct), (this.args = r), (this.liquid = n);
            }
            return (
                (t.prototype.render = function (t, e) {
                    var r,
                        n,
                        i = [];
                    try {
                        for (var o = vt(this.args), a = o.next(); !a.done; a = o.next()) {
                            var s = a.value;
                            Et(s) ? i.push([s[0], ze(s[1], e)]) : i.push(ze(s, e));
                        }
                    } catch (t) {
                        r = { error: t };
                    } finally {
                        try {
                            a && !a.done && (n = o.return) && n.call(o);
                        } finally {
                            if (r) throw r.error;
                        }
                    }
                    return this.impl.apply({ context: e, liquid: this.liquid }, yt([t], mt(i), !1));
                }),
                t
            );
        })(),
        pr = (function () {
            function t(t, e) {
                this.filters = [];
                var r = new sr(t, e.options.operatorsTrie);
                (this.initial = r.readExpression()),
                    (this.filters = r.readFilters().map(function (t) {
                        var r = t.name,
                            n = t.args;
                        return new lr(r, e.filters.get(r), n, e);
                    }));
            }
            return (
                (t.prototype.value = function (t, e) {
                    var r, n, i, o, a, s;
                    return ht(this, function (c) {
                        switch (c.label) {
                            case 0:
                                return (e = e || (t.opts.lenientIf && this.filters.length > 0 && "default" === this.filters[0].name)), [4, this.initial.evaluate(t, e)];
                            case 1:
                                (r = c.sent()), (c.label = 2);
                            case 2:
                                c.trys.push([2, 7, 8, 9]), (n = vt(this.filters)), (i = n.next()), (c.label = 3);
                            case 3:
                                return i.done ? [3, 6] : [4, i.value.render(r, t)];
                            case 4:
                                (r = c.sent()), (c.label = 5);
                            case 5:
                                return (i = n.next()), [3, 3];
                            case 6:
                                return [3, 9];
                            case 7:
                                return (o = c.sent()), (a = { error: o }), [3, 9];
                            case 8:
                                try {
                                    i && !i.done && (s = n.return) && s.call(n);
                                } finally {
                                    if (a) throw a.error;
                                }
                                return [7];
                            case 9:
                                return [2, r];
                        }
                    });
                }),
                t
            );
        })(),
        fr = (function (t) {
            function e(e, r, n) {
                var i = t.call(this, e) || this;
                i.name = e.name;
                var o = n.tags.get(e.name);
                return (i.impl = Object.create(o)), (i.impl.liquid = n), i.impl.parse && i.impl.parse(e, r), i;
            }
            return (
                pt(e, t),
                (e.prototype.render = function (t, e) {
                    var r, n;
                    return ht(this, function (i) {
                        switch (i.label) {
                            case 0:
                                return [4, new ur(this.token.args).render(t)];
                            case 1:
                                return (r = i.sent()), St((n = this.impl).render) ? [4, n.render(t, e, r)] : [3, 3];
                            case 2:
                                return [2, i.sent()];
                            case 3:
                                return [2];
                        }
                    });
                }),
                e
            );
        })(Pe),
        dr = (function (t) {
            function e(e, r) {
                var n = t.call(this, e) || this;
                return (n.value = new pr(e.content, r)), n;
            }
            return (
                pt(e, t),
                (e.prototype.render = function (t, e) {
                    var r;
                    return ht(this, function (n) {
                        switch (n.label) {
                            case 0:
                                return [4, this.value.value(t, !1)];
                            case 1:
                                return (r = n.sent()), e.write(r), [2];
                        }
                    });
                }),
                e
            );
        })(Pe),
        hr = (function (t) {
            function e(e) {
                var r = t.call(this, e) || this;
                return (r.str = e.getContent()), r;
            }
            return (
                pt(e, t),
                (e.prototype.render = function (t, e) {
                    return ht(this, function (t) {
                        return e.write(this.str), [2];
                    });
                }),
                e
            );
        })(Pe),
        vr = (function () {
            function t(t) {
                (this.liquid = t), (this.cache = this.liquid.options.cache), (this.fs = this.liquid.options.fs), (this.parseFile = this.cache ? this._parseFileCached : this._parseFile), (this.loader = new ae(this.liquid.options));
            }
            return (
                (t.prototype.parse = function (t, e) {
                    var r = new sr(t, this.liquid.options.operatorsTrie, e).readTopLevelTokens(this.liquid.options);
                    return this.parseTokens(r);
                }),
                (t.prototype.parseTokens = function (t) {
                    for (var e, r = []; (e = t.shift()); ) r.push(this.parseToken(e, t));
                    return r;
                }),
                (t.prototype.parseToken = function (t, e) {
                    try {
                        return _e(t) ? new fr(t, e, this.liquid) : be(t) ? new dr(t, this.liquid) : new hr(t);
                    } catch (e) {
                        throw new Zt(e, t);
                    }
                }),
                (t.prototype.parseStream = function (t) {
                    var e = this;
                    return new Le(t, function (t, r) {
                        return e.parseToken(t, r);
                    });
                }),
                (t.prototype._parseFileCached = function (t, e, r, n) {
                    var i, o, a;
                    return (
                        void 0 === r && (r = ne.Root),
                        ht(this, function (s) {
                            switch (s.label) {
                                case 0:
                                    return (i = this.loader.shouldLoadRelative(t) ? n + "," + t : r + ":" + t), [4, this.cache.read(i)];
                                case 1:
                                    if ((o = s.sent())) return [2, o];
                                    (a = pe(this._parseFile(t, e, r, n))), this.cache.write(i, a), (s.label = 2);
                                case 2:
                                    return s.trys.push([2, 4, , 5]), [4, a];
                                case 3:
                                    return [2, s.sent()];
                                case 4:
                                    return s.sent(), this.cache.remove(i), [3, 5];
                                case 5:
                                    return [2, []];
                            }
                        })
                    );
                }),
                (t.prototype._parseFile = function (t, e, r, n) {
                    var i, o, a, s;
                    return (
                        void 0 === r && (r = ne.Root),
                        ht(this, function (c) {
                            switch (c.label) {
                                case 0:
                                    return [4, this.loader.lookup(t, r, e, n)];
                                case 1:
                                    return (i = c.sent()), (a = (o = this.liquid).parse), e ? ((s = this.fs.readFileSync(i)), [3, 4]) : [3, 2];
                                case 2:
                                    return [4, this.fs.readFile(i)];
                                case 3:
                                    (s = c.sent()), (c.label = 4);
                                case 4:
                                    return [2, a.apply(o, [s, i])];
                            }
                        })
                    );
                }),
                t
            );
        })(),
        mr = {
            parse: function (t) {
                var e = new sr(t.args, this.liquid.options.operatorsTrie);
                (this.key = e.readIdentifier().content),
                    e.skipBlank(),
                    oe("=" === e.peek(), function () {
                        return "illegal token ".concat(t.getText());
                    }),
                    e.advance(),
                    (this.value = e.remaining());
            },
            render: function (t) {
                var e, r;
                return ht(this, function (n) {
                    switch (n.label) {
                        case 0:
                            return (e = t.bottom()), (r = this.key), [4, this.liquid._evalValue(this.value, t)];
                        case 1:
                            return (e[r] = n.sent()), [2];
                    }
                });
            },
        };
    function yr(t) {
        return Et(t)
            ? t
            : _t(t) && t.length > 0
            ? [t]
            : At(t)
            ? Object.keys(t).map(function (e) {
                  return [e, t[e]];
              })
            : [];
    }
    function gr(t) {
        return Et(t) ? t : [t];
    }
    var wr = (function (t) {
            function e(e, r, n) {
                var i = t.call(this) || this;
                return (i.i = 0), (i.length = e), (i.name = "".concat(n, "-").concat(r)), i;
            }
            return (
                pt(e, t),
                (e.prototype.next = function () {
                    this.i++;
                }),
                (e.prototype.index0 = function () {
                    return this.i;
                }),
                (e.prototype.index = function () {
                    return this.i + 1;
                }),
                (e.prototype.first = function () {
                    return 0 === this.i;
                }),
                (e.prototype.last = function () {
                    return this.i === this.length - 1;
                }),
                (e.prototype.rindex = function () {
                    return this.length - this.i;
                }),
                (e.prototype.rindex0 = function () {
                    return this.length - this.i - 1;
                }),
                (e.prototype.valueOf = function () {
                    return JSON.stringify(this);
                }),
                e
            );
        })(gt),
        br = ["offset", "limit", "reversed"],
        _r = {
            type: "block",
            parse: function (t, e) {
                var r,
                    n = this,
                    i = new sr(t.args, this.liquid.options.operatorsTrie),
                    o = i.readIdentifier(),
                    a = i.readIdentifier(),
                    s = i.readValue();
                oe(o.size() && "in" === a.content && s, function () {
                    return "illegal tag: ".concat(t.getText());
                }),
                    (this.variable = o.content),
                    (this.collection = s),
                    (this.hash = new ur(i.remaining())),
                    (this.templates = []),
                    (this.elseTemplates = []);
                var c = this.liquid.parser
                    .parseStream(e)
                    .on("start", function () {
                        return (r = n.templates);
                    })
                    .on("tag:else", function () {
                        return (r = n.elseTemplates);
                    })
                    .on("tag:endfor", function () {
                        return c.stop();
                    })
                    .on("template", function (t) {
                        return r.push(t);
                    })
                    .on("end", function () {
                        throw new Error("tag ".concat(t.getText(), " not closed"));
                    });
                c.start();
            },
            render: function (t, e) {
                var r, n, i, o, a, s, c, u, l, p, f, d, h;
                return ht(this, function (v) {
                    switch (v.label) {
                        case 0:
                            return (r = this.liquid.renderer), (i = yr), [4, ze(this.collection, t)];
                        case 1:
                            return (n = i.apply(void 0, [v.sent()])).length ? [3, 3] : [4, r.renderTemplates(this.elseTemplates, t, e)];
                        case 2:
                            return v.sent(), [2];
                        case 3:
                            return (o = "continue-" + this.variable + "-" + this.collection.getText()), t.push({ continue: t.getRegister(o) }), [4, this.hash.render(t)];
                        case 4:
                            (a = v.sent()),
                                t.pop(),
                                (s = this.liquid.options.orderedFilterParameters
                                    ? Object.keys(a).filter(function (t) {
                                          return br.includes(t);
                                      })
                                    : br.filter(function (t) {
                                          return void 0 !== a[t];
                                      })),
                                (n = s.reduce(function (t, e) {
                                    return "offset" === e
                                        ? ((r = t), (n = a.offset), r.slice(n))
                                        : "limit" === e
                                        ? (function (t, e) {
                                              return t.slice(0, e);
                                          })(t, a.limit)
                                        : (function (t) {
                                              return yt([], mt(t), !1).reverse();
                                          })(t);
                                    var r, n;
                                }, n)),
                                t.setRegister(o, (a.offset || 0) + n.length),
                                (c = { forloop: new wr(n.length, this.collection.getText(), this.variable) }),
                                t.push(c),
                                (v.label = 5);
                        case 5:
                            v.trys.push([5, 10, 11, 12]), (u = vt(n)), (l = u.next()), (v.label = 6);
                        case 6:
                            return l.done ? [3, 9] : ((p = l.value), (c[this.variable] = p), [4, r.renderTemplates(this.templates, t, e)]);
                        case 7:
                            if ((v.sent(), e.break)) return (e.break = !1), [3, 9];
                            (e.continue = !1), c.forloop.next(), (v.label = 8);
                        case 8:
                            return (l = u.next()), [3, 6];
                        case 9:
                            return [3, 12];
                        case 10:
                            return (f = v.sent()), (d = { error: f }), [3, 12];
                        case 11:
                            try {
                                l && !l.done && (h = u.return) && h.call(u);
                            } finally {
                                if (d) throw d.error;
                            }
                            return [7];
                        case 12:
                            return t.pop(), [2];
                    }
                });
            },
        };
    var Sr = {
        parse: function (t, e) {
            var r = this,
                n = new sr(t.args, this.liquid.options.operatorsTrie);
            (this.variable = (function (t) {
                var e = t.readIdentifier().content;
                if (e) return e;
                var r = t.readQuoted();
                if (r) return He(r);
            })(n)),
                oe(this.variable, function () {
                    return "".concat(t.args, " not valid identifier");
                }),
                (this.templates = []);
            var i = this.liquid.parser.parseStream(e);
            i
                .on("tag:endcapture", function () {
                    return i.stop();
                })
                .on("template", function (t) {
                    return r.templates.push(t);
                })
                .on("end", function () {
                    throw new Error("tag ".concat(t.getText(), " not closed"));
                }),
                i.start();
        },
        render: function (t) {
            var e;
            return ht(this, function (r) {
                switch (r.label) {
                    case 0:
                        return [4, this.liquid.renderer.renderTemplates(this.templates, t)];
                    case 1:
                        return (e = r.sent()), (t.bottom()[this.variable] = e), [2];
                }
            });
        },
    };
    var kr,
        xr = {
            parse: function (t, e) {
                var r = this;
                (this.cond = new pr(t.args, this.liquid)), (this.cases = []), (this.elseTemplates = []);
                var n = [],
                    i = this.liquid.parser
                        .parseStream(e)
                        .on("tag:when", function (t) {
                            n = [];
                            for (var e = new sr(t.args, r.liquid.options.operatorsTrie); !e.end(); ) {
                                var i = e.readValue();
                                r.cases.push({ val: i, templates: n }), e.readTo(",");
                            }
                        })
                        .on("tag:else", function () {
                            return (n = r.elseTemplates);
                        })
                        .on("tag:endcase", function () {
                            return i.stop();
                        })
                        .on("template", function (t) {
                            return n.push(t);
                        })
                        .on("end", function () {
                            throw new Error("tag ".concat(t.getText(), " not closed"));
                        });
                i.start();
            },
            render: function (t, e) {
                var r, n, i, o, a, s, c, u, l;
                return ht(this, function (p) {
                    switch (p.label) {
                        case 0:
                            return (r = this.liquid.renderer), (i = xt), [4, this.cond.value(t, t.opts.lenientIf)];
                        case 1:
                            (n = i.apply(void 0, [p.sent()])), (p.label = 2);
                        case 2:
                            p.trys.push([2, 7, 8, 9]), (o = vt(this.cases)), (a = o.next()), (p.label = 3);
                        case 3:
                            return a.done ? [3, 6] : ((s = a.value), ze(s.val, t, t.opts.lenientIf) !== n ? [3, 5] : [4, r.renderTemplates(s.templates, t, e)]);
                        case 4:
                            return p.sent(), [2];
                        case 5:
                            return (a = o.next()), [3, 3];
                        case 6:
                            return [3, 9];
                        case 7:
                            return (c = p.sent()), (u = { error: c }), [3, 9];
                        case 8:
                            try {
                                a && !a.done && (l = o.return) && l.call(o);
                            } finally {
                                if (u) throw u.error;
                            }
                            return [7];
                        case 9:
                            return [4, r.renderTemplates(this.elseTemplates, t, e)];
                        case 10:
                            return p.sent(), [2];
                    }
                });
            },
        },
        Tr = {
            parse: function (t, e) {
                var r = this.liquid.parser.parseStream(e);
                r
                    .on("token", function (t) {
                        "endcomment" === t.name && r.stop();
                    })
                    .on("end", function () {
                        throw new Error("tag ".concat(t.getText(), " not closed"));
                    }),
                    r.start();
            },
        };
    !(function (t) {
        (t[(t.OUTPUT = 0)] = "OUTPUT"), (t[(t.STORE = 1)] = "STORE");
    })(kr || (kr = {}));
    var qr = kr,
        Or = {
            parseFilePath: Er,
            renderFilePath: Pr,
            parse: function (t) {
                var e = t.args,
                    r = new sr(e, this.liquid.options.operatorsTrie);
                for (this.file = this.parseFilePath(r, this.liquid), this.currentFile = t.file; !r.end(); ) {
                    r.skipBlank();
                    var n = r.p,
                        i = r.readIdentifier();
                    if (("with" === i.content || "for" === i.content) && (r.skipBlank(), ":" !== r.peek())) {
                        var o = r.readValue();
                        if (o) {
                            var a = r.p,
                                s = void 0;
                            "as" === r.readIdentifier().content ? (s = r.readIdentifier()) : (r.p = a), (this[i.content] = { value: o, alias: s && s.content }), r.skipBlank(), "," === r.peek() && r.advance();
                            continue;
                        }
                    }
                    r.p = n;
                    break;
                }
                this.hash = new ur(r.remaining());
            },
            render: function (t, e) {
                var r, n, i, o, a, s, c, u, l, p, f, d, h, v, m, y, g, w, b, _;
                return ht(this, function (S) {
                    switch (S.label) {
                        case 0:
                            return (n = (r = this).liquid), (i = r.hash), [4, this.renderFilePath(this.file, t, n)];
                        case 1:
                            return (
                                oe((o = S.sent()), function () {
                                    return 'illegal filename "'.concat(o, '"');
                                }),
                                (a = new ie({}, t.opts, { sync: t.sync, globals: t.globals, strictVariables: t.strictVariables })),
                                (s = a.bottom()),
                                (c = ft),
                                (u = [s]),
                                [4, i.render(t)]
                            );
                        case 2:
                            if ((c.apply(void 0, u.concat([S.sent()])), this.with && ((l = this.with), (f = l.value), (d = l.alias), (s[d || o] = ze(f, t))), !this.for)) return [3, 12];
                            (p = this.for), (f = p.value), (d = p.alias), (h = yr((h = ze(f, t)))), (s.forloop = new wr(h.length, f.getText(), d)), (S.label = 3);
                        case 3:
                            S.trys.push([3, 9, 10, 11]), (v = vt(h)), (m = v.next()), (S.label = 4);
                        case 4:
                            return m.done ? [3, 8] : ((y = m.value), (s[d] = y), [4, n._parsePartialFile(o, a.sync, this.currentFile)]);
                        case 5:
                            return (w = S.sent()), [4, n.renderer.renderTemplates(w, a, e)];
                        case 6:
                            S.sent(), s.forloop.next(), (S.label = 7);
                        case 7:
                            return (m = v.next()), [3, 4];
                        case 8:
                            return [3, 11];
                        case 9:
                            return (g = S.sent()), (b = { error: g }), [3, 11];
                        case 10:
                            try {
                                m && !m.done && (_ = v.return) && _.call(v);
                            } finally {
                                if (b) throw b.error;
                            }
                            return [7];
                        case 11:
                            return [3, 15];
                        case 12:
                            return [4, n._parsePartialFile(o, a.sync, this.currentFile)];
                        case 13:
                            return (w = S.sent()), [4, n.renderer.renderTemplates(w, a, e)];
                        case 14:
                            S.sent(), (S.label = 15);
                        case 15:
                            return [2];
                    }
                });
            },
        };
    function Er(t, e) {
        if (e.options.dynamicPartials) {
            var r = t.readValue();
            if (void 0 === r) throw new TypeError('illegal argument "'.concat(t.input, '"'));
            return "none" === r.getText() ? null : Se(r) ? Lr(e.parse(He(r))) : r;
        }
        var n = yt([], mt(t.readFileNameTemplate(e.options)), !1),
            i = Lr(e.parser.parseTokens(n));
        return "none" === i ? null : i;
    }
    function Lr(t) {
        return 1 === t.length && we(t[0].token) ? t[0].token.getContent() : t;
    }
    function Pr(t, e, r) {
        return "string" == typeof t ? t : Array.isArray(t) ? r.renderer.renderTemplates(t, e) : ze(t, e);
    }
    var Ar = {
            parseFilePath: Er,
            renderFilePath: Pr,
            parse: function (t) {
                var e = t.args,
                    r = new sr(e, this.liquid.options.operatorsTrie);
                (this.file = this.parseFilePath(r, this.liquid)), (this.currentFile = t.file);
                var n = r.p;
                "with" === r.readIdentifier().content ? (r.skipBlank(), ":" !== r.peek() ? (this.withVar = r.readValue()) : (r.p = n)) : (r.p = n), (this.hash = new ur(r.remaining(), this.liquid.options.jekyllInclude));
            },
            render: function (t, e) {
                var r, n, i, o, a, s, c, u, l;
                return ht(this, function (p) {
                    switch (p.label) {
                        case 0:
                            return (n = (r = this).liquid), (i = r.hash), (o = r.withVar), (a = n.renderer), [4, this.renderFilePath(this.file, t, n)];
                        case 1:
                            return (
                                oe((s = p.sent()), function () {
                                    return 'illegal filename "'.concat(s, '"');
                                }),
                                (c = t.saveRegister("blocks", "blockMode")),
                                t.setRegister("blocks", {}),
                                t.setRegister("blockMode", qr.OUTPUT),
                                [4, i.render(t)]
                            );
                        case 2:
                            return (u = p.sent()), o && (u[s] = ze(o, t)), [4, n._parsePartialFile(s, t.sync, this.currentFile)];
                        case 3:
                            return (l = p.sent()), t.push(t.opts.jekyllInclude ? { include: u } : u), [4, a.renderTemplates(l, t, e)];
                        case 4:
                            return p.sent(), t.pop(), t.restoreRegister(c), [2];
                    }
                });
            },
        },
        Fr = {
            parse: function (t) {
                var e = new sr(t.args, this.liquid.options.operatorsTrie);
                this.variable = e.readIdentifier().content;
            },
            render: function (t, e) {
                var r = t.environments;
                Tt(r[this.variable]) || (r[this.variable] = 0), e.write(kt(--r[this.variable]));
            },
        },
        Nr = {
            parse: function (t) {
                var e = new sr(t.args, this.liquid.options.operatorsTrie),
                    r = e.readValue();
                for (e.skipBlank(), this.candidates = [], r && (":" === e.peek() ? ((this.group = r), e.advance()) : this.candidates.push(r)); !e.end(); ) {
                    var n = e.readValue();
                    n && this.candidates.push(n), e.readTo(",");
                }
                oe(this.candidates.length, function () {
                    return "empty candidates: ".concat(t.getText());
                });
            },
            render: function (t, e) {
                var r = ze(this.group, t),
                    n = "cycle:".concat(r, ":") + this.candidates.join(","),
                    i = t.getRegister("cycle"),
                    o = i[n];
                void 0 === o && (o = i[n] = 0);
                var a = this.candidates[o];
                (o = (o + 1) % this.candidates.length), (i[n] = o);
                var s = ze(a, t);
                e.write(s);
            },
        },
        jr = {
            parse: function (t, e) {
                var r,
                    n = this;
                (this.branches = []),
                    (this.elseTemplates = []),
                    this.liquid.parser
                        .parseStream(e)
                        .on("start", function () {
                            return n.branches.push({ predicate: new pr(t.args, n.liquid), templates: (r = []) });
                        })
                        .on("tag:elsif", function (t) {
                            return n.branches.push({ predicate: new pr(t.args, n.liquid), templates: (r = []) });
                        })
                        .on("tag:else", function () {
                            return (r = n.elseTemplates);
                        })
                        .on("tag:endif", function () {
                            this.stop();
                        })
                        .on("template", function (t) {
                            return r.push(t);
                        })
                        .on("end", function () {
                            throw new Error("tag ".concat(t.getText(), " not closed"));
                        })
                        .start();
            },
            render: function (t, e) {
                var r, n, i, o, a, s, c, u, l;
                return ht(this, function (p) {
                    switch (p.label) {
                        case 0:
                            (r = this.liquid.renderer), (p.label = 1);
                        case 1:
                            p.trys.push([1, 7, 8, 9]), (n = vt(this.branches)), (i = n.next()), (p.label = 2);
                        case 2:
                            return i.done ? [3, 6] : ((o = i.value), (a = o.predicate), (s = o.templates), [4, a.value(t, t.opts.lenientIf)]);
                        case 3:
                            return Ht(p.sent(), t) ? [4, r.renderTemplates(s, t, e)] : [3, 5];
                        case 4:
                            return p.sent(), [2];
                        case 5:
                            return (i = n.next()), [3, 2];
                        case 6:
                            return [3, 9];
                        case 7:
                            return (c = p.sent()), (u = { error: c }), [3, 9];
                        case 8:
                            try {
                                i && !i.done && (l = n.return) && l.call(n);
                            } finally {
                                if (u) throw u.error;
                            }
                            return [7];
                        case 9:
                            return [4, r.renderTemplates(this.elseTemplates, t, e)];
                        case 10:
                            return p.sent(), [2];
                    }
                });
            },
        },
        Cr = {
            parse: function (t) {
                var e = new sr(t.args, this.liquid.options.operatorsTrie);
                this.variable = e.readIdentifier().content;
            },
            render: function (t, e) {
                var r = t.environments;
                Tt(r[this.variable]) || (r[this.variable] = 0);
                var n = r[this.variable];
                r[this.variable]++, e.write(kt(n));
            },
        },
        Rr = {
            parseFilePath: Er,
            renderFilePath: Pr,
            parse: function (t, e) {
                var r = new sr(t.args, this.liquid.options.operatorsTrie);
                (this.file = this.parseFilePath(r, this.liquid)), (this.currentFile = t.file), (this.hash = new ur(r.remaining())), (this.tpls = this.liquid.parser.parseTokens(e));
            },
            render: function (t, e) {
                var r, n, i, o, a, s, c, u, l, p, f;
                return ht(this, function (d) {
                    switch (d.label) {
                        case 0:
                            return (n = (r = this).liquid), (i = r.hash), (o = r.file), (a = n.renderer), null !== o ? [3, 2] : (t.setRegister("blockMode", qr.OUTPUT), [4, a.renderTemplates(this.tpls, t, e)]);
                        case 1:
                            return d.sent(), [2];
                        case 2:
                            return [4, this.renderFilePath(this.file, t, n)];
                        case 3:
                            return (
                                oe((s = d.sent()), function () {
                                    return 'illegal filename "'.concat(s, '"');
                                }),
                                [4, n._parseLayoutFile(s, t.sync, this.currentFile)]
                            );
                        case 4:
                            return (c = d.sent()), t.setRegister("blockMode", qr.STORE), [4, a.renderTemplates(this.tpls, t)];
                        case 5:
                            return (
                                (u = d.sent()),
                                void 0 === (l = t.getRegister("blocks"))[""] &&
                                    (l[""] = function (t, e) {
                                        return e.write(u);
                                    }),
                                t.setRegister("blockMode", qr.OUTPUT),
                                (f = (p = t).push),
                                [4, i.render(t)]
                            );
                        case 6:
                            return f.apply(p, [d.sent()]), [4, a.renderTemplates(c, t, e)];
                        case 7:
                            return d.sent(), t.pop(), [2];
                    }
                });
            },
        },
        Dr = (function (t) {
            function e(e) {
                void 0 === e &&
                    (e = function () {
                        return "";
                    });
                var r = t.call(this) || this;
                return (r.superBlockRender = e), r;
            }
            return (
                pt(e, t),
                (e.prototype.super = function () {
                    return this.superBlockRender();
                }),
                e
            );
        })(gt),
        Vr = {
            parse: function (t, e) {
                var r = this,
                    n = /\w+/.exec(t.args);
                (this.block = n ? n[0] : ""),
                    (this.tpls = []),
                    this.liquid.parser
                        .parseStream(e)
                        .on("tag:endblock", function () {
                            this.stop();
                        })
                        .on("template", function (t) {
                            return r.tpls.push(t);
                        })
                        .on("end", function () {
                            throw new Error("tag ".concat(t.getText(), " not closed"));
                        })
                        .start();
            },
            render: function (t, e) {
                var r;
                return ht(this, function (n) {
                    switch (n.label) {
                        case 0:
                            return (r = this.getBlockRender(t)), t.getRegister("blockMode") !== qr.STORE ? [3, 1] : ((t.getRegister("blocks")[this.block] = r), [3, 3]);
                        case 1:
                            return [4, r(new Dr(), e)];
                        case 2:
                            n.sent(), (n.label = 3);
                        case 3:
                            return [2];
                    }
                });
            },
            getBlockRender: function (t) {
                var e = this.liquid,
                    r = this.tpls,
                    n = t.getRegister("blocks")[this.block],
                    i = function (n, i) {
                        return ht(this, function (o) {
                            switch (o.label) {
                                case 0:
                                    return t.push({ block: n }), [4, e.renderer.renderTemplates(r, t, i)];
                                case 1:
                                    return o.sent(), t.pop(), [2];
                            }
                        });
                    };
                return n
                    ? function (t, e) {
                          return n(
                              new Dr(function () {
                                  return i(t, e);
                              }),
                              e
                          );
                      }
                    : i;
            },
        },
        Mr = {
            parse: function (t, e) {
                var r = this;
                this.tokens = [];
                var n = this.liquid.parser.parseStream(e);
                n
                    .on("token", function (t) {
                        "endraw" === t.name ? n.stop() : r.tokens.push(t);
                    })
                    .on("end", function () {
                        throw new Error("tag ".concat(t.getText(), " not closed"));
                    }),
                    n.start();
            },
            render: function () {
                return this.tokens
                    .map(function (t) {
                        return t.getText();
                    })
                    .join("");
            },
        },
        Ir = (function (t) {
            function e(e, r, n, i) {
                var o = t.call(this, e, n, i) || this;
                return (o.length = e), (o.cols = r), o;
            }
            return (
                pt(e, t),
                (e.prototype.row = function () {
                    return Math.floor(this.i / this.cols) + 1;
                }),
                (e.prototype.col0 = function () {
                    return this.i % this.cols;
                }),
                (e.prototype.col = function () {
                    return this.col0() + 1;
                }),
                (e.prototype.col_first = function () {
                    return 0 === this.col0();
                }),
                (e.prototype.col_last = function () {
                    return this.col() === this.cols;
                }),
                e
            );
        })(wr),
        Br = {
            parse: function (t, e) {
                var r = this,
                    n = new sr(t.args, this.liquid.options.operatorsTrie),
                    i = n.readIdentifier();
                n.skipBlank();
                var o,
                    a = n.readIdentifier();
                oe(a && "in" === a.content, function () {
                    return "illegal tag: ".concat(t.getText());
                }),
                    (this.variable = i.content),
                    (this.collection = n.readValue()),
                    (this.hash = new ur(n.remaining())),
                    (this.templates = []);
                var s = this.liquid.parser
                    .parseStream(e)
                    .on("start", function () {
                        return (o = r.templates);
                    })
                    .on("tag:endtablerow", function () {
                        return s.stop();
                    })
                    .on("template", function (t) {
                        return o.push(t);
                    })
                    .on("end", function () {
                        throw new Error("tag ".concat(t.getText(), " not closed"));
                    });
                s.start();
            },
            render: function (t, e) {
                var r, n, i, o, a, s, c, u, l, p;
                return ht(this, function (f) {
                    switch (f.label) {
                        case 0:
                            return (n = yr), [4, ze(this.collection, t)];
                        case 1:
                            return (r = n.apply(void 0, [f.sent()])), [4, this.hash.render(t)];
                        case 2:
                            (i = f.sent()),
                                (o = i.offset || 0),
                                (a = void 0 === i.limit ? r.length : i.limit),
                                (r = r.slice(o, o + a)),
                                (s = i.cols || r.length),
                                (c = this.liquid.renderer),
                                (u = new Ir(r.length, s, this.collection.getText(), this.variable)),
                                (l = { tablerowloop: u }),
                                t.push(l),
                                (p = 0),
                                (f.label = 3);
                        case 3:
                            return p < r.length
                                ? ((l[this.variable] = r[p]),
                                  0 === u.col0() && (1 !== u.row() && e.write("</tr>"), e.write('<tr class="row'.concat(u.row(), '">'))),
                                  e.write('<td class="col'.concat(u.col(), '">')),
                                  [4, c.renderTemplates(this.templates, t, e)])
                                : [3, 6];
                        case 4:
                            f.sent(), e.write("</td>"), (f.label = 5);
                        case 5:
                            return p++, u.next(), [3, 3];
                        case 6:
                            return r.length && e.write("</tr>"), t.pop(), [2];
                    }
                });
            },
        },
        zr = {
            assign: mr,
            for: _r,
            capture: Sr,
            case: xr,
            comment: Tr,
            include: Ar,
            render: Or,
            decrement: Fr,
            increment: Cr,
            cycle: Nr,
            if: jr,
            layout: Rr,
            block: Vr,
            raw: Mr,
            tablerow: Br,
            unless: {
                parse: function (t, e) {
                    var r,
                        n = this;
                    (this.branches = []),
                        (this.elseTemplates = []),
                        this.liquid.parser
                            .parseStream(e)
                            .on("start", function () {
                                return n.branches.push({ predicate: new pr(t.args, n.liquid), test: Wt, templates: (r = []) });
                            })
                            .on("tag:elsif", function (t) {
                                return n.branches.push({ predicate: new pr(t.args, n.liquid), test: Ht, templates: (r = []) });
                            })
                            .on("tag:else", function () {
                                return (r = n.elseTemplates);
                            })
                            .on("tag:endunless", function () {
                                this.stop();
                            })
                            .on("template", function (t) {
                                return r.push(t);
                            })
                            .on("end", function () {
                                throw new Error("tag ".concat(t.getText(), " not closed"));
                            })
                            .start();
                },
                render: function (t, e) {
                    var r, n, i, o, a, s, c, u, l, p, f;
                    return ht(this, function (d) {
                        switch (d.label) {
                            case 0:
                                (r = this.liquid.renderer), (d.label = 1);
                            case 1:
                                d.trys.push([1, 7, 8, 9]), (n = vt(this.branches)), (i = n.next()), (d.label = 2);
                            case 2:
                                return i.done ? [3, 6] : ((o = i.value), (a = o.predicate), (s = o.test), (c = o.templates), [4, a.value(t, t.opts.lenientIf)]);
                            case 3:
                                return (u = d.sent()), s(u, t) ? [4, r.renderTemplates(c, t, e)] : [3, 5];
                            case 4:
                                return d.sent(), [2];
                            case 5:
                                return (i = n.next()), [3, 2];
                            case 6:
                                return [3, 9];
                            case 7:
                                return (l = d.sent()), (p = { error: l }), [3, 9];
                            case 8:
                                try {
                                    i && !i.done && (f = n.return) && f.call(n);
                                } finally {
                                    if (p) throw p.error;
                                }
                                return [7];
                            case 9:
                                return [4, r.renderTemplates(this.elseTemplates, t, e)];
                            case 10:
                                return d.sent(), [2];
                        }
                    });
                },
            },
            break: {
                render: function (t, e) {
                    e.break = !0;
                },
            },
            continue: {
                render: function (t, e) {
                    e.continue = !0;
                },
            },
            echo: {
                parse: function (t) {
                    this.value = new pr(t.args, this.liquid);
                },
                render: function (t, e) {
                    var r;
                    return ht(this, function (n) {
                        switch (n.label) {
                            case 0:
                                return [4, this.value.value(t, !1)];
                            case 1:
                                return (r = n.sent()), e.write(r), [2];
                        }
                    });
                },
            },
            liquid: {
                parse: function (t) {
                    var e = new sr(t.args, this.liquid.options.operatorsTrie).readLiquidTagTokens(this.liquid.options);
                    this.tpls = this.liquid.parser.parseTokens(e);
                },
                render: function (t, e) {
                    return ht(this, function (r) {
                        switch (r.label) {
                            case 0:
                                return [4, this.liquid.renderer.renderTemplates(this.tpls, t, e)];
                            case 1:
                                return r.sent(), [2];
                        }
                    });
                },
            },
        },
        Hr = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&#34;", "'": "&#39;" },
        Wr = { "&amp;": "&", "&lt;": "<", "&gt;": ">", "&#34;": '"', "&#39;": "'" };
    function Ur(t) {
        return kt(t).replace(/&|<|>|"|'/g, function (t) {
            return Hr[t];
        });
    }
    var Jr = Math.abs,
        Yr = Math.max,
        Qr = Math.min,
        $r = Math.ceil,
        Xr = Math.floor;
    var Gr = /%([-_0^#:]+)?(\d+)?([EO])?(.)/,
        Zr = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        Kr = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        tn = Zr.map(nn),
        en = Kr.map(nn),
        rn = { 1: "st", 2: "nd", 3: "rd", default: "th" };
    function nn(t) {
        return t.slice(0, 3);
    }
    function on(t) {
        var e = (function (t) {
            var e = t.getFullYear();
            return !(0 != (3 & e) || !(e % 100 || (e % 400 == 0 && e)));
        })(t)
            ? 29
            : 28;
        return [31, e, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    }
    function an(t) {
        for (var e = 0, r = 0; r < t.getMonth(); ++r) e += on(t)[r];
        return e + t.getDate();
    }
    function sn(t, e) {
        var r = an(t) + (e - t.getDay()),
            n = 7 - new Date(t.getFullYear(), 0, 1).getDay() + e;
        return String(Math.floor((r - n) / 7) + 1);
    }
    var cn = { d: 2, e: 2, H: 2, I: 2, j: 3, k: 2, l: 2, L: 3, m: 2, M: 2, S: 2, U: 2, W: 2 },
        un = { a: " ", A: " ", b: " ", B: " ", c: " ", e: " ", k: " ", l: " ", p: " ", P: " " },
        ln = {
            a: function (t) {
                return en[t.getDay()];
            },
            A: function (t) {
                return Kr[t.getDay()];
            },
            b: function (t) {
                return tn[t.getMonth()];
            },
            B: function (t) {
                return Zr[t.getMonth()];
            },
            c: function (t) {
                return t.toLocaleString();
            },
            C: function (t) {
                return (function (t) {
                    return parseInt(t.getFullYear().toString().substring(0, 2), 10);
                })(t);
            },
            d: function (t) {
                return t.getDate();
            },
            e: function (t) {
                return t.getDate();
            },
            H: function (t) {
                return t.getHours();
            },
            I: function (t) {
                return String(t.getHours() % 12 || 12);
            },
            j: function (t) {
                return an(t);
            },
            k: function (t) {
                return t.getHours();
            },
            l: function (t) {
                return String(t.getHours() % 12 || 12);
            },
            L: function (t) {
                return t.getMilliseconds();
            },
            m: function (t) {
                return t.getMonth() + 1;
            },
            M: function (t) {
                return t.getMinutes();
            },
            N: function (t, e) {
                var r = Number(e.width) || 9;
                return (function (t, e, r) {
                    return (
                        void 0 === r && (r = " "),
                        jt(t, e, r, function (t, e) {
                            return t + e;
                        })
                    );
                })(String(t.getMilliseconds()).substr(0, r), r, "0");
            },
            p: function (t) {
                return t.getHours() < 12 ? "AM" : "PM";
            },
            P: function (t) {
                return t.getHours() < 12 ? "am" : "pm";
            },
            q: function (t) {
                return (function (t) {
                    var e = t.getDate().toString(),
                        r = parseInt(e.slice(-1));
                    return rn[r] || rn.default;
                })(t);
            },
            s: function (t) {
                return Math.round(t.getTime() / 1e3);
            },
            S: function (t) {
                return t.getSeconds();
            },
            u: function (t) {
                return t.getDay() || 7;
            },
            U: function (t) {
                return sn(t, 0);
            },
            w: function (t) {
                return t.getDay();
            },
            W: function (t) {
                return sn(t, 1);
            },
            x: function (t) {
                return t.toLocaleDateString();
            },
            X: function (t) {
                return t.toLocaleTimeString();
            },
            y: function (t) {
                return t.getFullYear().toString().substring(2, 4);
            },
            Y: function (t) {
                return t.getFullYear();
            },
            z: function (t, e) {
                var r = Math.abs(t.getTimezoneOffset()),
                    n = Math.floor(r / 60),
                    i = r % 60;
                return (t.getTimezoneOffset() > 0 ? "-" : "+") + Nt(n, 2, "0") + (e.flags[":"] ? ":" : "") + Nt(i, 2, "0");
            },
            t: function () {
                return "\t";
            },
            n: function () {
                return "\n";
            },
            "%": function () {
                return "%";
            },
        };
    function pn(t, e) {
        var r,
            n,
            i = mt(e, 5),
            o = i[0],
            a = i[1],
            s = void 0 === a ? "" : a,
            c = i[2],
            u = i[3],
            l = i[4],
            p = ln[l];
        if (!p) return o;
        var f = {};
        try {
            for (var d = vt(s), h = d.next(); !h.done; h = d.next()) {
                f[h.value] = !0;
            }
        } catch (t) {
            r = { error: t };
        } finally {
            try {
                h && !h.done && (n = d.return) && n.call(d);
            } finally {
                if (r) throw r.error;
            }
        }
        var v,
            m = String(p(t, { flags: f, width: c, modifier: u })),
            y = un[l] || "0",
            g = c || cn[l] || 0;
        return (
            f["^"]
                ? (m = m.toUpperCase())
                : f["#"] &&
                  (m = yt([], mt((v = m)), !1).some(function (t) {
                      return t >= "a" && t <= "z";
                  })
                      ? v.toUpperCase()
                      : v.toLowerCase()),
            f._ ? (y = " ") : f[0] && (y = "0"),
            f["-"] && (g = 0),
            Nt(m, g, y)
        );
    }
    ln.h = ln.b;
    var fn = new Date().getTimezoneOffset(),
        dn = /([zZ]|([+-])(\d{2}):(\d{2}))$/,
        hn = (function () {
            function t(e, r) {
                if (e instanceof t) (this.date = e.date), (r = e.timezoneOffset);
                else {
                    var n = 6e4 * (fn - r),
                        i = new Date(e).getTime() + n;
                    this.date = new Date(i);
                }
                this.timezoneOffset = r;
            }
            return (
                (t.prototype.getTime = function () {
                    return this.date.getTime();
                }),
                (t.prototype.getMilliseconds = function () {
                    return this.date.getMilliseconds();
                }),
                (t.prototype.getSeconds = function () {
                    return this.date.getSeconds();
                }),
                (t.prototype.getMinutes = function () {
                    return this.date.getMinutes();
                }),
                (t.prototype.getHours = function () {
                    return this.date.getHours();
                }),
                (t.prototype.getDay = function () {
                    return this.date.getDay();
                }),
                (t.prototype.getDate = function () {
                    return this.date.getDate();
                }),
                (t.prototype.getMonth = function () {
                    return this.date.getMonth();
                }),
                (t.prototype.getFullYear = function () {
                    return this.date.getFullYear();
                }),
                (t.prototype.toLocaleTimeString = function (t) {
                    return this.date.toLocaleTimeString(t);
                }),
                (t.prototype.toLocaleDateString = function (t) {
                    return this.date.toLocaleDateString(t);
                }),
                (t.prototype.getTimezoneOffset = function () {
                    return this.timezoneOffset;
                }),
                (t.createDateFixedToTimezone = function (e) {
                    var r = e.match(dn);
                    if (r && "Z" === r[1]) return new t(+new Date(e), 0);
                    if (r && r[2] && r[3] && r[4]) {
                        var n = mt(r, 5),
                            i = n[2],
                            o = n[3],
                            a = n[4],
                            s = ("+" === i ? -1 : 1) * (60 * parseInt(o, 10) + parseInt(a, 10));
                        return new t(+new Date(e), s);
                    }
                    return new Date(e);
                }),
                t
            );
        })();
    var vn = Object.freeze({
            __proto__: null,
            escape: Ur,
            escapeOnce: function (t) {
                return Ur(
                    (function (t) {
                        return String(t).replace(/&(amp|lt|gt|#34|#39);/g, function (t) {
                            return Wr[t];
                        });
                    })(t)
                );
            },
            newlineToBr: function (t) {
                return t.replace(/\n/g, "<br />\n");
            },
            stripHtml: function (t) {
                return t.replace(/<script.*?<\/script>|<!--.*?-->|<style.*?<\/style>|<.*?>/g, "");
            },
            abs: Jr,
            atLeast: Yr,
            atMost: Qr,
            ceil: $r,
            dividedBy: function (t, e) {
                return t / e;
            },
            floor: Xr,
            minus: function (t, e) {
                return t - e;
            },
            modulo: function (t, e) {
                return t % e;
            },
            times: function (t, e) {
                return t * e;
            },
            round: function (t, e) {
                void 0 === e && (e = 0);
                var r = Math.pow(10, e);
                return Math.round(t * r) / r;
            },
            plus: function (t, e) {
                return Number(t) + Number(e);
            },
            sortNatural: function (t, e) {
                return t && t.sort
                    ? void 0 !== e
                        ? yt([], mt(t), !1).sort(function (t, r) {
                              return Dt(t[e], r[e]);
                          })
                        : yt([], mt(t), !1).sort(Dt)
                    : [];
            },
            urlDecode: function (t) {
                return t.split("+").map(decodeURIComponent).join(" ");
            },
            urlEncode: function (t) {
                return t.split(" ").map(encodeURIComponent).join("+");
            },
            join: function (t, e) {
                return t.join(void 0 === e ? " " : e);
            },
            last: function (t) {
                return Et(t) ? Pt(t) : "";
            },
            first: function (t) {
                return Et(t) ? t[0] : "";
            },
            reverse: function (t) {
                return yt([], mt(t), !1).reverse();
            },
            sort: function (t, e) {
                var r = this,
                    n = function (t) {
                        return e ? r.context.getFromScope(t, e.split(".")) : t;
                    };
                return gr(t).sort(function (t, e) {
                    return (t = n(t)) < (e = n(e)) ? -1 : t > e ? 1 : 0;
                });
            },
            size: function (t) {
                return (t && t.length) || 0;
            },
            map: function (t, e) {
                var r = this;
                return gr(t).map(function (t) {
                    return r.context.getFromScope(t, e.split("."));
                });
            },
            compact: function (t) {
                return gr(t).filter(function (t) {
                    return !Ot(t);
                });
            },
            concat: function (t, e) {
                return gr(t).concat(e);
            },
            slice: function (t, e, r) {
                return void 0 === r && (r = 1), (e = e < 0 ? t.length + e : e), t.slice(e, e + r);
            },
            where: function (t, e, r) {
                var n = this;
                return gr(t).filter(function (t) {
                    var i = n.context.getFromScope(t, String(e).split("."));
                    return void 0 === r ? Ht(i, n.context) : zt(r) ? r.equals(i) : i === r;
                });
            },
            uniq: function (t) {
                var e = {};
                return (t || []).filter(function (t) {
                    return !e.hasOwnProperty(String(t)) && ((e[String(t)] = !0), !0);
                });
            },
            date: function (t, e) {
                var r,
                    n = this.context.opts;
                return (function (t) {
                    return (t instanceof Date || t instanceof hn) && !isNaN(t.getTime());
                })((r = "now" === t || "today" === t ? new Date() : Tt(t) ? new Date(1e3 * t) : _t(t) ? (/^\d+$/.test(t) ? new Date(1e3 * +t) : n.preserveTimezones ? hn.createDateFixedToTimezone(t) : new Date(t)) : t))
                    ? (n.hasOwnProperty("timezoneOffset") && (r = new hn(r, n.timezoneOffset)),
                      (function (t, e) {
                          for (var r, n = "", i = e; (r = Gr.exec(i)); ) (n += i.slice(0, r.index)), (i = i.slice(r.index + r[0].length)), (n += pn(t, r));
                          return n + i;
                      })(r, e))
                    : t;
            },
            Default: function (t, e) {
                for (var r = [], n = 2; n < arguments.length; n++) r[n - 2] = arguments[n];
                return Et(t) || _t(t) ? (t.length ? t : e) : (!1 !== (t = xt(t)) || !new Map(r).get("allow_false")) && (Wt(t, this.context) ? e : t);
            },
            json: function (t) {
                return JSON.stringify(t);
            },
            append: function (t, e) {
                return oe(2 === arguments.length, "append expect 2 arguments"), kt(t) + kt(e);
            },
            prepend: function (t, e) {
                return oe(2 === arguments.length, "prepend expect 2 arguments"), kt(e) + kt(t);
            },
            lstrip: function (t) {
                return kt(t).replace(/^\s+/, "");
            },
            downcase: function (t) {
                return kt(t).toLowerCase();
            },
            upcase: function (t) {
                return kt(t).toUpperCase();
            },
            remove: function (t, e) {
                return kt(t).split(String(e)).join("");
            },
            removeFirst: function (t, e) {
                return kt(t).replace(String(e), "");
            },
            rstrip: function (t) {
                return kt(t).replace(/\s+$/, "");
            },
            split: function (t, e) {
                return kt(t).split(String(e));
            },
            strip: function (t) {
                return kt(t).trim();
            },
            stripNewlines: function (t) {
                return kt(t).replace(/\n/g, "");
            },
            capitalize: function (t) {
                return (t = kt(t)).charAt(0).toUpperCase() + t.slice(1).toLowerCase();
            },
            replace: function (t, e, r) {
                return kt(t).split(String(e)).join(r);
            },
            replaceFirst: function (t, e, r) {
                return kt(t).replace(String(e), r);
            },
            truncate: function (t, e, r) {
                return void 0 === e && (e = 50), void 0 === r && (r = "..."), (t = kt(t)).length <= e ? t : t.substr(0, e - r.length) + r;
            },
            truncatewords: function (t, e, r) {
                void 0 === e && (e = 15), void 0 === r && (r = "...");
                var n = t.split(/\s+/),
                    i = n.slice(0, e).join(" ");
                return n.length >= e && (i += r), i;
            },
        }),
        mn = (function () {
            function t() {
                this.impls = {};
            }
            return (
                (t.prototype.get = function (t) {
                    var e = this.impls[t];
                    return (
                        oe(e, function () {
                            return 'tag "'.concat(t, '" not found');
                        }),
                        e
                    );
                }),
                (t.prototype.set = function (t, e) {
                    this.impls[t] = e;
                }),
                t
            );
        })(),
        yn = (function () {
            function t(t, e) {
                (this.strictFilters = t), (this.liquid = e), (this.impls = {});
            }
            return (
                (t.prototype.get = function (t) {
                    var e = this.impls[t];
                    return (
                        oe(e || !this.strictFilters, function () {
                            return "undefined filter: ".concat(t);
                        }),
                        e
                    );
                }),
                (t.prototype.set = function (t, e) {
                    this.impls[t] = e;
                }),
                (t.prototype.create = function (t, e) {
                    return new lr(t, this.get(t), e, this.liquid);
                }),
                t
            );
        })(),
        gn = (function () {
            function t(t) {
                var e = this;
                void 0 === t && (t = {}),
                    (this.options = (function (t) {
                        if (
                            (t.hasOwnProperty("operators") && (t.operatorsTrie = Yt(t.operators)),
                            t.hasOwnProperty("root") && (t.hasOwnProperty("partials") || (t.partials = t.root), t.hasOwnProperty("layouts") || (t.layouts = t.root)),
                            t.hasOwnProperty("cache"))
                        ) {
                            var e = void 0;
                            (e = "number" == typeof t.cache ? (t.cache > 0 ? new Mt(t.cache) : void 0) : "object" == typeof t.cache ? t.cache : t.cache ? new Mt(1024) : void 0), (t.cache = e);
                        }
                        return (
                            !(t = ft(ft(ft({}, Qt), t.jekyllInclude ? { dynamicPartials: !1 } : {}), t)).fs.dirname &&
                                t.relativeReference &&
                                (console.warn("[LiquidJS] `fs.dirname` is required for relativeReference, set relativeReference to `false` to suppress this warning, or provide implementation for `fs.dirname`"), (t.relativeReference = !1)),
                            (t.root = $t(t.root)),
                            (t.partials = $t(t.partials)),
                            (t.layouts = $t(t.layouts)),
                            t
                        );
                    })(t)),
                    (this.parser = new vr(this)),
                    (this.renderer = new me()),
                    (this.filters = new yn(this.options.strictFilters, this)),
                    (this.tags = new mn()),
                    Lt(zr, function (t, r) {
                        return e.registerTag(Rt(r), t);
                    }),
                    Lt(vn, function (t, r) {
                        return e.registerFilter(Rt(r), t);
                    });
            }
            return (
                (t.prototype.parse = function (t, e) {
                    return this.parser.parse(t, e);
                }),
                (t.prototype._render = function (t, e, r) {
                    var n = new ie(e, this.options, r);
                    return this.renderer.renderTemplates(t, n);
                }),
                (t.prototype.render = function (t, e, r) {
                    return dt(this, void 0, void 0, function () {
                        return ht(this, function (n) {
                            return [2, fe(this._render(t, e, ft(ft({}, r), { sync: !1 })))];
                        });
                    });
                }),
                (t.prototype.renderSync = function (t, e, r) {
                    return de(this._render(t, e, ft(ft({}, r), { sync: !0 })));
                }),
                (t.prototype.renderToNodeStream = function (t, e, r) {
                    void 0 === r && (r = {});
                    var n = new ie(e, this.options, r);
                    return this.renderer.renderTemplatesToNodeStream(t, n);
                }),
                (t.prototype._parseAndRender = function (t, e, r) {
                    var n = this.parse(t);
                    return this._render(n, e, r);
                }),
                (t.prototype.parseAndRender = function (t, e, r) {
                    return dt(this, void 0, void 0, function () {
                        return ht(this, function (n) {
                            return [2, fe(this._parseAndRender(t, e, ft(ft({}, r), { sync: !1 })))];
                        });
                    });
                }),
                (t.prototype.parseAndRenderSync = function (t, e, r) {
                    return de(this._parseAndRender(t, e, ft(ft({}, r), { sync: !0 })));
                }),
                (t.prototype._parsePartialFile = function (t, e, r) {
                    return this.parser.parseFile(t, e, ne.Partials, r);
                }),
                (t.prototype._parseLayoutFile = function (t, e, r) {
                    return this.parser.parseFile(t, e, ne.Layouts, r);
                }),
                (t.prototype.parseFile = function (t) {
                    return dt(this, void 0, void 0, function () {
                        return ht(this, function (e) {
                            return [2, fe(this.parser.parseFile(t, !1))];
                        });
                    });
                }),
                (t.prototype.parseFileSync = function (t) {
                    return de(this.parser.parseFile(t, !0));
                }),
                (t.prototype.renderFile = function (t, e, r) {
                    return dt(this, void 0, void 0, function () {
                        var n;
                        return ht(this, function (i) {
                            switch (i.label) {
                                case 0:
                                    return [4, this.parseFile(t)];
                                case 1:
                                    return (n = i.sent()), [2, this.render(n, e, r)];
                            }
                        });
                    });
                }),
                (t.prototype.renderFileSync = function (t, e, r) {
                    var n = this.parseFileSync(t);
                    return this.renderSync(n, e, r);
                }),
                (t.prototype.renderFileToNodeStream = function (t, e, r) {
                    return dt(this, void 0, void 0, function () {
                        var n;
                        return ht(this, function (i) {
                            switch (i.label) {
                                case 0:
                                    return [4, this.parseFile(t)];
                                case 1:
                                    return (n = i.sent()), [2, this.renderToNodeStream(n, e, r)];
                            }
                        });
                    });
                }),
                (t.prototype._evalValue = function (t, e) {
                    return new pr(t, this).value(e, !1);
                }),
                (t.prototype.evalValue = function (t, e) {
                    return dt(this, void 0, void 0, function () {
                        return ht(this, function (r) {
                            return [2, fe(this._evalValue(t, e))];
                        });
                    });
                }),
                (t.prototype.evalValueSync = function (t, e) {
                    return de(this._evalValue(t, e));
                }),
                (t.prototype.registerFilter = function (t, e) {
                    this.filters.set(t, e);
                }),
                (t.prototype.registerTag = function (t, e) {
                    this.tags.set(t, e);
                }),
                (t.prototype.plugin = function (e) {
                    return e.call(this, t);
                }),
                (t.prototype.express = function () {
                    var t = this,
                        e = !0;
                    return function (r, n, i) {
                        var o, a, s;
                        if (e) {
                            e = !1;
                            var c = $t(this.root);
                            (o = t.options.root).unshift.apply(o, yt([], mt(c), !1)), (a = t.options.layouts).unshift.apply(a, yt([], mt(c), !1)), (s = t.options.partials).unshift.apply(s, yt([], mt(c), !1));
                        }
                        t.renderFile(r, n).then(function (t) {
                            return i(null, t);
                        }, i);
                    };
                }),
                t
            );
        })();
    function wn(t) {
        return (
            (wn =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      }),
            wn(t)
        );
    }
    function bn() {
        return (
            (bn =
                "undefined" != typeof Reflect && Reflect.get
                    ? Reflect.get
                    : function (t, e, r) {
                          var n = _n(t, e);
                          if (n) {
                              var i = Object.getOwnPropertyDescriptor(n, e);
                              return i.get ? i.get.call(arguments.length < 3 ? t : r) : i.value;
                          }
                      }),
            bn.apply(this, arguments)
        );
    }
    function _n(t, e) {
        for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = qn(t)); );
        return t;
    }
    function Sn(t, e) {
        return (
            (Sn =
                Object.setPrototypeOf ||
                function (t, e) {
                    return (t.__proto__ = e), t;
                }),
            Sn(t, e)
        );
    }
    function kn(t) {
        var e = (function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
                return !1;
            }
        })();
        return function () {
            var r,
                n = qn(t);
            if (e) {
                var i = qn(this).constructor;
                r = Reflect.construct(n, arguments, i);
            } else r = n.apply(this, arguments);
            return xn(this, r);
        };
    }
    function xn(t, e) {
        if (e && ("object" === wn(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return Tn(t);
    }
    function Tn(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
    }
    function qn(t) {
        return (
            (qn = Object.setPrototypeOf
                ? Object.getPrototypeOf
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  }),
            qn(t)
        );
    }
    function On(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    function En(t, e) {
        for (var r = 0; r < e.length; r++) {
            var n = e[r];
            (n.enumerable = n.enumerable || !1), (n.configurable = !0), "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
    }
    function Ln(t, e, r) {
        return e && En(t.prototype, e), r && En(t, r), Object.defineProperty(t, "prototype", { writable: !1 }), t;
    }
    var Pn,
        An = (function () {
            function t(e, r, n) {
                On(this, t), (this.availableVariants = []), (this.currentSelected = {}), (this.optionWithValues = n), (this.stock = {}), (this.swatchWrapperSel = r), (this.productData = e);
            }
            return (
                Ln(t, [
                    {
                        key: "init",
                        value: function () {
                            (this.stock = this.createStock()), this.getAvailableVariants(), this.initStock(), this.addSwatchEvent(), this.selectOnInit();
                        },
                    },
                    {
                        key: "createStock",
                        value: function () {
                            var t = {};
                            return (
                                this.optionWithValues.forEach(function (e) {
                                    t[e.name] = {};
                                }),
                                t
                            );
                        },
                    },
                    {
                        key: "initStock",
                        value: function () {
                            var t = this;
                            this.availableVariants.forEach(function (e) {
                                Object.keys(t.stock).forEach(function (r) {
                                    t.stock[r][e[r]] = !0;
                                });
                            });
                        },
                    },
                    {
                        key: "doSelect",
                        value: function (t, e) {
                            var r = this;
                            this.currentSelected[t] = e;
                            var n = this.createStock();
                            (n[t] = this.stock[t]), (this.stock = n);
                            var i = Object.keys(this.stock);
                            this.availableVariants.forEach(function (e) {
                                i.forEach(function (n) {
                                    if (t !== n) {
                                        for (var o = 0; o < i.length; o++) {
                                            var a = i[o];
                                            if (a !== n && r.currentSelected[a] && e[a] !== r.currentSelected[a]) return;
                                        }
                                        r.stock[n][e[n]] = !0;
                                    }
                                });
                            });
                        },
                    },
                    {
                        key: "disableSwatch",
                        value: function () {
                            var t = this;
                            this.swatchWrapperSel.querySelectorAll(".vario-variants").forEach(function (e, r) {
                                e.querySelectorAll(".vario-variant").forEach(function (r) {
                                    var n = r.getAttribute("data-value"),
                                        i = (r.getAttribute("data-position"), e.getAttribute("data-variant-name"));
                                    if (t.stock[i][n]) r.classList.remove("vario-disabled", "vario-disabled-grayscale", "vario-disabled-hidden");
                                    else if (varioCustomizer.sold_out.show_sold_out_variants)
                                        "gray-out" === varioCustomizer.sold_out.style && r.classList.add("vario-disabled-grayscale"), "cross" === varioCustomizer.sold_out.style && r.classList.add("vario-disabled");
                                    else {
                                        if (!varioCustomizer.sold_out.show_sold_out_variants && t.currentSelected[i] === n) return;
                                        r.classList.add("vario-disabled-hidden");
                                    }
                                });
                            });
                        },
                    },
                    {
                        key: "getAvailableVariants",
                        value: function () {
                            var t = this;
                            this.productData.variants.forEach(function (e) {
                                if (e.available) {
                                    var r = {};
                                    t.optionWithValues.forEach(function (t, n) {
                                        r[t.name] = e["option".concat(n + 1)];
                                    }),
                                        t.availableVariants.push(r);
                                }
                            });
                        },
                    },
                    {
                        key: "isNotExistVariant",
                        value: function (t) {
                            var e = this;
                            return this.optionWithValues.some(function (r, n) {
                                return e.currentSelected[r.name] != t["option".concat(n + 1)];
                            });
                        },
                    },
                    {
                        key: "addSwatchEvent",
                        value: function () {
                            var t = this;
                            document.body.addEventListener("change", function (e) {
                                var r = e.target,
                                    n = (parseInt(r.getAttribute("data-position")), r.value),
                                    i = r.getAttribute("data-variant-name"),
                                    o = e.target.closest(".vario-all-variant-wrapper");
                                t.swatchWrapperSel.contains(r) &&
                                    r.classList.contains("vario-variants") &&
                                    ((r.closest(".vario-variant-wrapper").querySelector(".vario-variant-selected").innerText = r.value),
                                    t.doSelect(i, n),
                                    t.disableSwatch(),
                                    o.dispatchEvent(
                                        new CustomEvent("vario-swatch-selected", { bubbles: !0, detail: { swatchWrapperSel: t.swatchWrapperSel, selectSel: r, currentVariant: t.findCurrentVariant(), swatchInstance: t, element: this } })
                                    ));
                            }),
                                document.body.addEventListener("click", function (e) {
                                    var r = e.target.closest("li.vario-variant"),
                                        n = e.target.closest("ul.vario-variants"),
                                        i = e.target.closest(".vario-variant-wrapper"),
                                        o = e.target.closest(".vario-all-variant-wrapper");
                                    if (t.swatchWrapperSel.contains(n) && r) {
                                        var a = r.getAttribute("data-value"),
                                            s = (parseInt(r.getAttribute("data-position")), i.getAttribute("data-variant-name"));
                                        t.doSelect(s, a), (r.closest(".vario-variant-wrapper").querySelector(".vario-variant-selected").innerText = a);
                                        var c = n.querySelector(".sv_active");
                                        c && c.classList.remove("sv_active"),
                                            r.classList.add("sv_active"),
                                            t.disableSwatch(),
                                            o.dispatchEvent(
                                                new CustomEvent("vario-swatch-clicked", {
                                                    bubbles: !0,
                                                    detail: { swatchWrapperSel: t.swatchWrapperSel, ulSel: n, liSel: r, currentVariant: t.findCurrentVariant(), swatchInstance: t, element: this },
                                                })
                                            );
                                    }
                                });
                        },
                    },
                    {
                        key: "findCurrentVariant",
                        value: function () {
                            var t = this;
                            return this.productData.variants.find(function (e) {
                                return e.available && !t.isNotExistVariant(e);
                            });
                        },
                    },
                    {
                        key: "selectOnInit",
                        value: function () {
                            var t = this;
                            this.swatchWrapperSel.querySelectorAll(".vario-variants").forEach(function (e, r) {
                                var n = e.getAttribute("data-variant-name");
                                "SELECT" == e.nodeName
                                    ? t.currentSelected[n] &&
                                      ((e.value = t.currentSelected[n]),
                                      Object.values(e.options).forEach(function (r) {
                                          r.value == t.currentSelected[n] &&
                                              ((r.selected = "selected"), t.doSelect(n, t.currentSelected[n]), (e.closest(".vario-variant-wrapper").querySelector(".vario-variant-selected").innerText = t.currentSelected[n]));
                                      }))
                                    : e.querySelectorAll(".vario-variant").forEach(function (e) {
                                          e.getAttribute("data-value") != t.currentSelected[n] || e.classList.contains("vario-plus-btn")
                                              ? e.classList.remove("sv_active")
                                              : (t.doSelect(n, t.currentSelected[n]), e.classList.add("sv_active"), (e.closest(".vario-variant-wrapper").querySelector(".vario-variant-selected").innerText = t.currentSelected[n]));
                                      });
                            });
                        },
                    },
                ]),
                t
            );
        })(),
        Fn = (function (t) {
            !(function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && Sn(t, e);
            })(r, t);
            var e = kn(r);
            function r(t, n, i) {
                var o;
                return (
                    On(this, r),
                    ((o = e.call(this)).currentVariantId = null),
                    (o.formSelector = null),
                    (o.selectors = {
                        singleOptionSelector:
                            "select.Form__Select, select.single-option-selector,.options-selection__input-select,.product__variant,.select-wrapper>select,.form__input--select,.product-option-select select,.selector-wrapper select,.form-element-select select,.product-form__option-select,.pf-element select,select.option-selector,.product-details__option-wrapper select,.product-form__input select,select.pf-variant-select,select.product-form__input,select.form-control,select.product-option.custom-select,.variant-input-wrap>select,select.product-option-value-item,#product-variants>select#product-selectors,.product-variant select.product-variant-container",
                        radioSelectors:
                            '.swatch-items-wrapper > .swatch-element input[type="radio"], .BlockSwatchList input[type="radio"], .option-selector__btns input[type="radio"].opt-btn.js-option, input[type="radio"].single-option-selector__radio,input[type="radio"].variant-input,input.form-check-input[type="radio"],input.product-variant__input[type="radio"],input.product-form__single-selector[type="radio"],.radio__fieldset input[type="radio"],input.swatch__input[type="radio"],.swatch-element input[type="radio"],input.option-value-input[type="radio"],input.radios--input[type="radio"],input.single-option-selector[type="radio"],.form-swatch-item input[type="radio"],.product-options input[type="radio"],.single-option-radio input[type="radio"],.product-form__input input[type="radio"],.pf-variant-radio input[type="radio"],input.single-option-selector-product-template[type="radio"],.options-selection__option-values input[type="radio"],.swatch__option input[type="radio"],input.ColorSwatch__Radio[type="radio"],.variant-input input[type="radio"],input.SizeSwatch__Radio[type="radio"],.radio-btn input[type="radio"]',
                        customSelectors:
                            ".cc-select__option, .sf__variant-swatch > .product-option-item, .OptionSelector .Popover__Content .Popover__ValueList button.Popover__Value, input.disclosure--input,.js-option.active,.product__chip,.Popover__Value,.popout-list__option,.clickyboxes a,li.nt-swatch.swatch_pr_item",
                        hideElements:
                            ".selector-wrapper,.radio-wrapper,fieldset,.options-selection__select-wrapper,.disclosure--root,.product-options[data-section-name],.js-enabled.product-form__option,.product-form__select,.product-option,.product-option-select,.product-variant,.variant-wrapper,.product-form__variants,.js-enabled,.swatch.selectors,.swatch_options,.ProductForm__Variants,.form-element-wrapper,.variant-group,.swatch,.product-single__swatches,.product-form--variants,.product__variants,.product-swatches,.product-options .option,.product-options,.swatches__container,.product-form-grid-select,.product-details__option-wrapper",
                    }),
                    (o.onSwatchClicked = o.onSwatchClicked.bind(Tn(o))),
                    (o.onSwatchSelected = o.onSwatchSelected.bind(Tn(o))),
                    o
                );
            }
            return (
                Ln(r, [
                    {
                        key: "init",
                        value: function () {
                            var t = this;
                            (this.productData = JSON.parse(document.querySelector("#vario-product-json").innerHTML)),
                                (this.optionWithValues = window.vario_options_with_values),
                                this.appendControl(this.productData).then(function (e) {
                                    var n = document.querySelectorAll('form[action*="/cart/add"]');
                                    n.length > 1 ? ((t.formSelector = document.querySelector('form[action*="/cart/add"][data-product-form]')), !t.formSelector && (t.formSelector = n[0])) : (t.formSelector = n[0]),
                                        (t.swatchWrapperSel = e),
                                        t.getCurrentOptions(),
                                        bn(qn(r.prototype), "init", t).call(t),
                                        (varioCustomizer.sold_out.show_sold_out_variants || "automatic" === varioCustomizer.sold_out.hide_style) && t.disableSwatch(),
                                        t.detectFormValueChanged(),
                                        e.parentNode.addEventListener("vario-swatch-clicked", t.onSwatchClicked),
                                        e.parentNode.addEventListener("vario-swatch-selected", t.onSwatchSelected),
                                        t.generateTooltip();
                                });
                        },
                    },
                    {
                        key: "detectFormValueChanged",
                        value: function () {
                            var t = this;
                            if (this.formSelector) {
                                var e = this.formSelector.querySelector('select[name="id"], input[name="id"]');
                                e &&
                                    e.addEventListener("change", function e(r) {
                                        var n = r.target.value;
                                        t.currentVariantId != n && (t.getCurrentOptions(), t.selectOnInit()), r.target.removeEventListener("change", e);
                                    });
                            }
                        },
                    },
                    {
                        key: "onSwatchClicked",
                        value: function (t) {
                            var e = t.detail.liSel;
                            this.triggerControlEvent(e.getAttribute("data-value"), parseInt(e.getAttribute("data-position")));
                        },
                    },
                    {
                        key: "onSwatchSelected",
                        value: function (t) {
                            var e = t.detail.selectSel;
                            this.triggerControlEvent(e.value, parseInt(e.getAttribute("data-position")));
                        },
                    },
                    {
                        key: "generateTooltip",
                        value: function () {
                            var t = document.querySelectorAll(".vario-variant[data-v-tooltip]");
                            t &&
                                t.forEach(function (t) {
                                    var e = document.createElement("span");
                                    if ("name" === varioCustomizer.swatches.hover_effect) {
                                        e.classList.add("vario-variant-tip");
                                        e.appendChild(
                                            (function (t) {
                                                return document.createTextNode(t);
                                            })(t.getAttribute("data-value"))
                                        );
                                    } else if ("zoom" === varioCustomizer.swatches.hover_effect) {
                                        e.classList.add("vario-variant-tip"), t.classList.add("vario-variant-zoom-tip");
                                        e.appendChild(
                                            (function (t) {
                                                return document.createTextNode(t);
                                            })(t.getAttribute("data-value"))
                                        );
                                    } else if ("image" === varioCustomizer.swatches.hover_effect) {
                                        if (t.querySelector(".swatch-color")) {
                                            e.classList.add("vario-variant-tip");
                                            e.appendChild(
                                                (function (t) {
                                                    return document.createTextNode(t);
                                                })(t.getAttribute("data-value"))
                                            );
                                        } else {
                                            e.classList.add("vario-variant-img-tip");
                                            var r = t.querySelector(".swatch-image");
                                            if (r) {
                                                var n = r.style.backgroundImage,
                                                    i = /\([\s\S]*\)/.exec(n)[0].replaceAll(/_50x|_120x|_360x|\(|\)|\"/gi, "");
                                                if (i) {
                                                    var o = document.createElement("img");
                                                    (o.width = 150), (o.height = 150), (o.alt = "swatch image"), (o.src = i), e.appendChild(o);
                                                }
                                                var a = document.createElement("span");
                                                (a.innerText = t.getAttribute("data-value")), e.appendChild(a);
                                            }
                                        }
                                    }
                                    document.body.appendChild(e);
                                    var s = 8;
                                    "zoom" === varioCustomizer.swatches.hover_effect && (s = 14);
                                    var c = ut(t, e, { modifiers: [{ name: "offset", options: { offset: [0, s] } }], placement: "undefined" != typeof vario_tip_placement ? vario_tip_placement : "top" });
                                    t.addEventListener("mouseenter", function () {
                                        e.setAttribute("data-tip-show", ""), c.update();
                                    }),
                                        t.addEventListener("mouseleave", function () {
                                            e.removeAttribute("data-tip-show");
                                        });
                                });
                        },
                    },
                    {
                        key: "triggerControlEvent",
                        value: function (t, e) {
                            var r = this,
                                n = document.querySelectorAll(this.selectors.singleOptionSelector);
                            if (n.length) {
                                var i = Object.values(n).find(function (e) {
                                        return Object.values(e.options).find(function (e) {
                                            return e.value == t;
                                        });
                                    }),
                                    o = Object.values(n).filter(function (e) {
                                        return Object.values(e).find(function (e) {
                                            return e.value == t;
                                        });
                                    });
                                o.length && (1 == o.length ? i && (i.value = t) && i.dispatchEvent(new Event("change", { bubbles: !0 })) : o[0] && (o[0].value = t) && o[0].dispatchEvent(new Event("change", { bubbles: !0 }))),
                                    !i &&
                                        this.productData.variants.find(function (e) {
                                            if (!r.isNotExistVariant(e)) {
                                                var i = Object.values(n).find(function (r) {
                                                    return Object.values(r.options).find(function (r) {
                                                        return r.value == t || r.value == e.id;
                                                    });
                                                });
                                                i && (i.value = e.id) && i.dispatchEvent(new Event("change", { bubbles: !0 }));
                                            }
                                        });
                            }
                            var a = document.querySelectorAll(this.selectors.radioSelectors);
                            if (a.length) {
                                var s = Object.values(a).filter(function (e) {
                                    return e.value == t;
                                });
                                if (s.length)
                                    if (1 == s.length) s[0] && s[0].click();
                                    else {
                                        var c = s.find(function (t) {
                                            return t.dataset.index == "option".concat(e + 1) || t.dataset.optionPosition == e + 1;
                                        });
                                        c && c.click();
                                    }
                                else
                                    this.productData.variants.forEach(function (t) {
                                        if (!r.isNotExistVariant(t)) {
                                            var e = Object.values(a).find(function (e) {
                                                return e.value == t.id;
                                            });
                                            e && e.click();
                                        }
                                    });
                            }
                            var u = document.querySelectorAll(this.selectors.customSelectors);
                            u.length &&
                                u.forEach(function (e) {
                                    e.parentNode.querySelector('[data-value="'.concat(t, '"]')) && e.parentNode.querySelector('[data-value="'.concat(t, '"]')).click(),
                                        e.parentNode.querySelector('[data-button="'.concat(t, '"]')) && e.parentNode.querySelector('[data-button="'.concat(t, '"]')).click(),
                                        e.parentNode.querySelector('[data-escape="'.concat(t, '"]')) && e.parentNode.querySelector('[data-escape="'.concat(t, '"]')).click();
                                });
                        },
                    },
                    {
                        key: "appendControl",
                        value: function (t) {
                            var e = this,
                                r = new DOMParser(),
                                n = document.querySelector("#vario-product-variant-template").innerHTML,
                                i = new gn();
                            return (
                                i.registerFilter("img_url", function (t, e, r) {
                                    if (!t) return "";
                                    r = r || !1;
                                    var n = t.split(".").pop(),
                                        i = t.lastIndexOf(n) - 1;
                                    return t.slice(0, i) + "_" + e + t.slice(i);
                                }),
                                new Promise(function (o, a) {
                                    var s = i.parse(n);
                                    i.render(s, { product: t, options_with_values: window.vario_options_with_values, varioSettings: window.varioSettings }).then(function (t) {
                                        var n = r.parseFromString(t, "text/html").querySelector(".vario-all-variant-wrapper");
                                        if ("prynwan.myshopify.com" == Shopify.shop)
                                            return (
                                                document
                                                    .querySelector('form[action*="/cart/add"] .main-product__block.main-product__block-short_description')
                                                    .parentNode.insertBefore(n, document.querySelector('form[action*="/cart/add"] .main-product__block.main-product__block-short_description')),
                                                void o(n)
                                            );
                                        if ("officefurniturewarehouse.myshopify.com" == Shopify.shop)
                                            return (
                                                document
                                                    .querySelector('form[action*="/cart/add"] .product-form__info-item.product-form__info-item--quantity')
                                                    .parentNode.insertBefore(n, document.querySelector('form[action*="/cart/add"] .product-form__info-item.product-form__info-item--quantity')),
                                                void o(n)
                                            );
                                        if ("amaze-shoppeee.myshopify.com" == Shopify.shop)
                                            return (
                                                document
                                                    .querySelector('form[action*="/cart/add"] .product-meta .jdgm-widget.jdgm-preview-badge')
                                                    .parentNode.insertBefore(n, document.querySelector('form[action*="/cart/add"] .product-meta .jdgm-widget.jdgm-preview-badge')),
                                                void o(n)
                                            );
                                        if ("smartype-5660.myshopify.com" == Shopify.shop) return document.querySelector('form[id^="AddToCartForm').prepend(n), void o(n);
                                        if ("luv-cobeauty.myshopify.com" == Shopify.shop)
                                            return (
                                                document
                                                    .querySelector('form[action*="/cart/add"] .grid--uniform.product-single__addtocart')
                                                    .parentNode.insertBefore(n, document.querySelector('form[action*="/cart/add"] .grid--uniform.product-single__addtocart')),
                                                void o(n)
                                            );
                                        if ("moonkie-shop.myshopify.com" == Shopify.shop)
                                            return (
                                                document.querySelector('form[action*="/cart/add"] .product-single__variants').parentNode.insertBefore(n, document.querySelector('form[action*="/cart/add"] .product-single__variants')),
                                                void o(n)
                                            );
                                        if ("maxxofertas1.myshopify.com" == Shopify.shop) return document.querySelector('form[action*="/cart/add"]').parentNode.insertBefore(n, document.querySelector('form[action*="/cart/add"]')), void o(n);
                                        if ("mariobemer.myshopify.com" == Shopify.shop)
                                            return (
                                                document.querySelector('form[action*="/cart/add"] .ProductMeta__ShareButtons').parentNode.insertBefore(n, document.querySelector('form[action*="/cart/add"] .ProductMeta__ShareButtons')),
                                                void o(n)
                                            );
                                        if ("shop-junto.myshopify.com" == Shopify.shop) return document.querySelector('form[action*="/cart/add"] .single_product__options').prepend(n), void o(n);
                                        if ("emi-theory.myshopify.com" == Shopify.shop)
                                            return (
                                                document.querySelector('form[action*="/cart/add"] .product-form__variants').parentNode.insertBefore(n, document.querySelector('form[action*="/cart/add"] .product-form__variants')), void o(n)
                                            );
                                        if ("helrym.myshopify.com" == Shopify.shop)
                                            return document.querySelector('form[action*="/cart/add"] .product-description').parentNode.insertBefore(n, document.querySelector('form[action*="/cart/add"] .product-description')), void o(n);
                                        if ("lawrence-russel.myshopify.com" == Shopify.shop)
                                            return (
                                                document
                                                    .querySelector('form[action*="/cart/add"] .product-info .product-single__variants')
                                                    .parentNode.insertBefore(n, document.querySelector('form[action*="/cart/add"] .product-info .product-single__variants')),
                                                void o(n)
                                            );
                                        if ("jocafs-ab.myshopify.com" == Shopify.shop)
                                            return document.querySelector('form[action*="/cart/add"] .product-swatches').parentNode.insertBefore(n, document.querySelector('form[action*="/cart/add"] .product-swatches')), void o(n);
                                        if ("dd-s-bridal-shop.myshopify.com" == Shopify.shop)
                                            return (
                                                document.querySelector('form[action*="/cart/add"] .product-form__controls-group').parentNode.insertBefore(n, document.querySelector('form[action*="/cart/add"] .product-form__controls-group')),
                                                void o(n)
                                            );
                                        if ("tickingdepot.myshopify.com" == Shopify.shop)
                                            return (
                                                document.querySelector('form[action*="/cart/add"] .product-details__options') &&
                                                    document.querySelector('form[action*="/cart/add"] .product-details__options').parentNode.insertBefore(n, document.querySelector('form[action*="/cart/add"] .product-details__options')),
                                                void o(n)
                                            );
                                        if ("tkgky-nie.myshopify.com" == Shopify.shop)
                                            return (
                                                document.querySelector('form[action*="/cart/add"] .product-detail__quantity-row').parentNode.insertBefore(n, document.querySelector('form[action*="/cart/add"] .product-detail__quantity-row')),
                                                void o(n)
                                            );
                                        if ("hello-sunny-day.myshopify.com" == Shopify.shop)
                                            return document.querySelector('form[action*="/cart/add"] .original-selector').parentNode.insertBefore(n, document.querySelector('form[action*="/cart/add"] .original-selector')), void o(n);
                                        if ("db-custom-branding.myshopify.com" == Shopify.shop)
                                            return (
                                                document.querySelector('form[action*="/cart/add"] .product-form__variants').parentNode.insertBefore(n, document.querySelector('form[action*="/cart/add"] .product-form__variants')), void o(n)
                                            );
                                        if ("amici-pelosetti-store.myshopify.com" == Shopify.shop)
                                            return document.querySelector('form[action*="/cart/add"].product-single__form').parentNode.insertBefore(n, document.querySelector('form[action*="/cart/add"].product-single__form')), void o(n);
                                        if ("hawkins-woodshop.myshopify.com" == Shopify.shop)
                                            return (
                                                document.querySelector('form[action*="/cart/add"] .product-form__variants').parentNode.insertBefore(n, document.querySelector('form[action*="/cart/add"] .product-form__variants')), void o(n)
                                            );
                                        if ("brightrsleep.myshopify.com" == Shopify.shop && document.querySelector('[data-pf-type="ProductVariantSwatches"],[data-pf-type="ProductVariant"]'))
                                            return (
                                                document
                                                    .querySelector('[data-pf-type="ProductVariantSwatches"],[data-pf-type="ProductVariant"]')
                                                    .parentNode.insertBefore(n, document.querySelector('[data-pf-type="ProductVariantSwatches"],[data-pf-type="ProductVariant"]')),
                                                void o(n)
                                            );
                                        if ("earth-eden-brand.myshopify.com" == Shopify.shop && document.querySelector(".product-form-option"))
                                            return document.querySelector(".product-form-option").parentNode.insertBefore(n, document.querySelector(".product-form-option")), void o(n);
                                        if ("linions.myshopify.com" == Shopify.shop && document.querySelector(".product-single__variants.product-form__item"))
                                            return document.querySelector(".product-single__variants.product-form__item").parentNode.insertBefore(n, document.querySelector(".product-single__variants.product-form__item")), void o(n);
                                        if ("vilan-hotcutes.myshopify.com" == Shopify.shop && document.querySelector(".product-swatches"))
                                            return document.querySelector(".product-swatches").parentNode.insertBefore(n, document.querySelector(".product-swatches")), void o(n);
                                        if ("oppo-italia-store.myshopify.com" == Shopify.shop && document.querySelector(".variants.clearfix"))
                                            return document.querySelector(".variants.clearfix").parentNode.insertBefore(n, document.querySelector(".variants.clearfix")), void o(n);
                                        if ("clue22-com.myshopify.com" == Shopify.shop && document.querySelector("div.product__text"))
                                            return document.querySelector("div.product__text").parentNode.insertBefore(n, document.querySelector("div.product__text").nextSibling), void o(n);
                                        if ("customstore12569.myshopify.com" == Shopify.shop && document.querySelector("#ProductPrice"))
                                            return document.querySelector("#ProductPrice").parentNode.insertBefore(n, document.querySelector("#ProductPrice").nextSibling), void o(n);
                                        if ("tie-fly.myshopify.com" == Shopify.shop && document.querySelector(".product-form__input.product-form__quantity"))
                                            return document.querySelector(".product-form__input.product-form__quantity").parentNode.insertBefore(n, document.querySelector(".product-form__input.product-form__quantity")), void o(n);
                                        if (865 == Shopify.theme.theme_store_id) return document.querySelector('form[action*="/cart/add"] .purchase-section').prepend(n), void o(n);
                                        if (846 == Shopify.theme.theme_store_id) return e.formSelector.querySelector(".product-details").insertBefore(n, e.formSelector.querySelector(".variant-group")), void o(n);
                                        if (window.__pagefly_setting__) {
                                            var i = document.querySelectorAll('[data-pf-type="ProductVariant"]');
                                            if (
                                                (i.length &&
                                                    i.forEach(function (t) {
                                                        t.parentNode.insertBefore(n, t);
                                                    }),
                                                document.querySelector(".vario-variant-wrapper"))
                                            )
                                                return void o(n);
                                        }
                                        document.querySelector('form[action*="/cart/add"]').prepend(n), o(n);
                                    });
                                })
                            );
                        },
                    },
                    {
                        key: "getCurrentOptions",
                        value: function () {
                            var t = this;
                            if (this.formSelector) {
                                var e = this.formSelector.querySelector('select[name="id"], input[name="id"]');
                                if (e) {
                                    this.currentVariantId = e.value;
                                    var r = e.value,
                                        n = window.location.href.match(/\?variant=(\d+)$/);
                                    window.__pagefly_setting__ && n && n[1] != r && (r = n[1]);
                                    var i = this.productData.variants.find(function (t) {
                                        return t.id == r;
                                    });
                                    if (i) {
                                        var o = this.createStock();
                                        Object.keys(o).forEach(function (e, r) {
                                            t.currentSelected[e] = i["option".concat(r + 1)];
                                        });
                                    }
                                }
                            }
                        },
                    },
                ]),
                r
            );
        })(An),
        Nn = (function () {
            function t() {
                On(this, t),
                    (this.productSelectors = []),
                    (this.optionSelectors = []),
                    (this.collectionProducts = []),
                    (this.priceRegularSelectors =
                        ".product-grid-item__content > p,.price__regular .price-item--regular,.grid-product__price,.product-item--price>span>small[aria-hidden=true],.price__sale .price-item--sale,.card__price,.grid-link__meta,.product-thumbnail__header .product__price,.product__prices,.product-item__price-wrapper,.product-card__price,.product-price .theme-money,.product-thumbnail__price,.price .amount.theme-money,.product-item__price-list .price,.ProductItem__Price.Price,.pricing .price,.product-grid--price .money,#CollectionProductGrid .money"),
                    (this.priceCompareSelectors = ".price__sale .price-item--sale, .price__compare .price-item--regular,.product-item--price s small,.on-sale .sale-tag,.grid-product__on-sale"),
                    (this.productImgSelectors =
                        ".product-item__thumbnail .lazy-image, .grid-product__image-mask .grid__image-ratio, .spc__main-img .sf-image, .product-card a.product-card__image, .product-list-item-thumbnail > a,.grid-view-item__image-wrapper, .product-grid-item__image, .collection-template .product-index .prod-image .box-ratio, .collection-image--zoom-effect .grid__image,.ProductItem__ImageWrapper.ProductItem__ImageWrapper--withAlternateImage,.product-card__image-wrapper,.grid-product__image-link,.product-grid-image,.card__image-wrapper,.product__img-wrapper,.product__image-wrapper,.product-item__image-wrapper,.card--product .media, .product-thumbnail__media,.grid-product__image-mask .image-wrap,.rimage-wrapper,.product-image__wrapper,.ProductItem__ImageWrapper,.image-container-position,.card__media .media,.grid-view-item-image,.featured-collection__image"),
                    (this.productImgWrapper = ".product-item--vertical, .card-wrapper, .product-index, .product-grid-item, article.product-list-item"),
                    (this.moneyFormat = null),
                    this.init(),
                    (this.onSwatchClicked = this.onSwatchClicked.bind(this)),
                    (this.onSwatchSelected = this.onSwatchSelected.bind(this));
            }
            return (
                Ln(t, [
                    {
                        key: "init",
                        value: function () {
                            var t = this;
                            if (
                                ((this.moneyFormat = this.getCurrentMoneyFormat()),
                                (this.productSelectors = document.querySelectorAll(".vario-collecion-product-tml")),
                                (this.optionSelectors = document.querySelectorAll(".vario-collecion-product-options-tml")),
                                this.productSelectors.length && this.optionSelectors.length)
                            ) {
                                var e = this.productSelectors.length;
                                this.productSelectors.forEach(function (r, n) {
                                    var i = JSON.parse(r.innerHTML),
                                        o = JSON.parse(t.optionSelectors[n].innerHTML);
                                    t.appendControl(r, i, o).then(function (a) {
                                        var s = new An(i, a, o);
                                        s.init(),
                                            t.collectionProducts.push(s),
                                            r.parentNode.addEventListener("vario-swatch-clicked", t.onSwatchClicked),
                                            r.parentNode.addEventListener("vario-swatch-selected", t.onSwatchSelected),
                                            n === e - 1 && t.generateTooltip(),
                                            t.doSelectOnInit(o, s);
                                    });
                                });
                            }
                        },
                    },
                    {
                        key: "generateTooltip",
                        value: function () {
                            var t = document.querySelectorAll(".vario-variant[data-v-tooltip]");
                            t &&
                                t.forEach(function (t) {
                                    var e = document.createElement("span");
                                    if ("name" === varioCustomizer.swatches.hover_effect) {
                                        e.classList.add("vario-variant-tip");
                                        e.appendChild(
                                            (function (t) {
                                                return document.createTextNode(t);
                                            })(t.getAttribute("data-value"))
                                        );
                                    } else if ("zoom" === varioCustomizer.swatches.hover_effect) {
                                        e.classList.add("vario-variant-tip"), t.classList.add("vario-variant-zoom-tip");
                                        e.appendChild(
                                            (function (t) {
                                                return document.createTextNode(t);
                                            })(t.getAttribute("data-value"))
                                        );
                                    } else if ("image" === varioCustomizer.swatches.hover_effect) {
                                        if (t.querySelector(".swatch-color")) {
                                            e.classList.add("vario-variant-tip");
                                            e.appendChild(
                                                (function (t) {
                                                    return document.createTextNode(t);
                                                })(t.getAttribute("data-value"))
                                            );
                                        } else {
                                            e.classList.add("vario-variant-img-tip");
                                            var r = t.querySelector(".swatch-image");
                                            if (r) {
                                                var n = r.style.backgroundImage,
                                                    i = /\([\s\S]*\)/.exec(n)[0].replaceAll(/_50x|_120x|_360x|\(|\)|\"/gi, "");
                                                if (i) {
                                                    var o = document.createElement("img");
                                                    (o.width = 150), (o.height = 150), (o.alt = "swatch image"), (o.src = i), e.appendChild(o);
                                                }
                                                var a = document.createElement("span");
                                                (a.innerText = t.getAttribute("data-value")), e.appendChild(a);
                                            }
                                        }
                                    }
                                    document.body.appendChild(e);
                                    var s = 8;
                                    "zoom" === varioCustomizer.swatches.hover_effect && (s = 14);
                                    var c = ut(t, e, { modifiers: [{ name: "offset", options: { offset: [0, s] } }], placement: "undefined" != typeof vario_tip_placement ? vario_tip_placement : "top" });
                                    t.addEventListener("mouseenter", function () {
                                        e.setAttribute("data-tip-show", ""), c.update();
                                    }),
                                        t.addEventListener("mouseleave", function () {
                                            e.removeAttribute("data-tip-show");
                                        });
                                });
                        },
                    },
                    {
                        key: "getCurrentMoneyFormat",
                        value: function () {
                            var t, e, r, n, i, o, a, s, c, u, l, p, f, d, h;
                            return null !== (t = window) && void 0 !== t && t.moneyFormat
                                ? window.moneyFormat
                                : null !== (e = window) && void 0 !== e && null !== (r = e.theme) && void 0 !== r && r.moneyFormat
                                ? theme.moneyFormat
                                : null !== (n = window) && void 0 !== n && null !== (i = n.theme) && void 0 !== i && null !== (o = i.settings) && void 0 !== o && o.moneyFormat
                                ? theme.settings.moneyFormat
                                : null !== (a = window) && void 0 !== a && null !== (s = a.theme) && void 0 !== s && s.money_format
                                ? theme.money_format
                                : null !== (c = window) && void 0 !== c && null !== (u = c.theme) && void 0 !== u && null !== (l = u.shop) && void 0 !== l && l.money_format
                                ? theme.shop.money_format
                                : null !== (p = window) && void 0 !== p && null !== (f = p.wetheme) && void 0 !== f && f.moneyFormat
                                ? wetheme.moneyFormat
                                : null !== (d = window) && void 0 !== d && null !== (h = d.StyleHatch) && void 0 !== h && h.currencyFormat
                                ? StyleHatch.currencyFormat
                                : window.VarioCurrencyFormat;
                        },
                    },
                    {
                        key: "formatMoney",
                        value: function (t, e) {
                            "string" == typeof t && (t = t.replace(".", ""));
                            var r = "",
                                n = /\{\{\s*(\w+)\s*\}\}/,
                                i = e || this.moneyFormat;
                            function o(t, e) {
                                return void 0 === t ? e : t;
                            }
                            function a(t, e, r, n) {
                                if (((e = o(e, 2)), (r = o(r, ",")), (n = o(n, ".")), isNaN(t) || null == t)) return 0;
                                var i = (t = (t / 100).toFixed(e)).split(".");
                                return i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + r) + (i[1] ? n + i[1] : "");
                            }
                            switch (i.match(n)[1]) {
                                case "amount":
                                    r = a(t, 2);
                                    break;
                                case "amount_no_decimals":
                                    r = a(t, 0);
                                    break;
                                case "amount_with_apostrophe_separator":
                                    r = a(t, 2, "'", ".");
                                    break;
                                case "amount_with_comma_separator":
                                    r = a(t, 2, ".", ",");
                                    break;
                                case "amount_no_decimals_with_comma_separator":
                                    r = a(t, 0, ".", ",");
                                    break;
                                case "amount_with_dot_separator":
                                    r = a(t, 2, ",", ".");
                            }
                            return i.replace(n, r);
                        },
                    },
                    {
                        key: "appendControl",
                        value: function (t, e, r) {
                            var n = new DOMParser(),
                                i = document.querySelector("#vario-product-variant-template").innerHTML,
                                o = new gn();
                            return (
                                o.registerFilter("img_url", function (t, e, r) {
                                    if (!t) return "";
                                    r = r || !1;
                                    var n = t.split(".").pop(),
                                        i = t.lastIndexOf(n) - 1;
                                    return t.slice(0, i) + "_" + e + t.slice(i);
                                }),
                                new Promise(function (a, s) {
                                    var c,
                                        u,
                                        l,
                                        p = o.parse(i);
                                    o.render(p, {
                                        product: e,
                                        options_with_values: r,
                                        varioSettings: window.varioSettings,
                                        page_type_collection: !(
                                            null === (c = window) ||
                                            void 0 === c ||
                                            null === (u = c.meta) ||
                                            void 0 === u ||
                                            null === (l = u.page) ||
                                            void 0 === l ||
                                            !l.pageType ||
                                            "collection" != window.meta.page.pageType
                                        ),
                                    }).then(function (e) {
                                        var r = n.parseFromString(e, "text/html").querySelector(".vario-all-variant-wrapper");
                                        t.parentNode.insertBefore(r, t), a(r);
                                    });
                                })
                            );
                        },
                    },
                    {
                        key: "onSwatchSelected",
                        value: function (t) {
                            var e = t.detail,
                                r = (e.selectSel, e.currentVariant),
                                n = e.swatchInstance,
                                i = t.target.parentNode;
                            this.changeImage(i, r), this.changePrice(i, r, n);
                        },
                    },
                    {
                        key: "onSwatchClicked",
                        value: function (t) {
                            var e = t.detail,
                                r = e.ulSel,
                                n = e.liSel,
                                i = e.currentVariant,
                                o = e.swatchInstance,
                                a = t.target.parentNode;
                            if (n.classList.contains("vario-plus-btn")) {
                                var s = n.getAttribute("data-action");
                                if ("link_product_page" == s) {
                                    var c = n.getAttribute("data-handle");
                                    window.location = "/products/" + c;
                                } else if ("show_swatches" == s) {
                                    r.querySelectorAll(".vario-variant").forEach(function (t) {
                                        t.classList.contains("vario-plus-btn") ? t.classList.add("vario-pl-hidden") : t.classList.contains("vario-pl-hidden") && t.classList.remove("vario-pl-hidden");
                                    });
                                }
                            } else if ("undefined" != typeof vario_variant_action && "link_product_page" == vario_variant_action) {
                                var u = n.getAttribute("data-handle");
                                window.location = "/products/" + u;
                            } else this.changeImage(a, i), this.changePrice(a, i, o), document.querySelector("body").classList.add("vario_clicked");
                        },
                    },
                    {
                        key: "changeImgUrlSize",
                        value: function (t, e) {
                            if (!t) return "";
                            var r = t.split(".").pop(),
                                n = t.lastIndexOf(r) - 1;
                            return t.slice(0, n) + "_" + e + t.slice(n);
                        },
                    },
                    {
                        key: "changeImage",
                        value: function (t, e) {
                            var r = t.querySelector(this.productImgSelectors);
                            if (r) r = r.querySelector("img");
                            else {
                                var n = t.closest(this.productImgWrapper).querySelector(this.productImgSelectors);
                                n && (r = n.querySelector("img"));
                            }
                            r &&
                                null != e &&
                                e.featured_image &&
                                ((r.dataset.srcset = this.changeImgUrlSize(e.featured_image.src, varioCustomizer.collection.image_size + "x")),
                                (r.src = this.changeImgUrlSize(e.featured_image.src, varioCustomizer.collection.image_size + "x")),
                                (r.srcset = this.changeImgUrlSize(e.featured_image.src, varioCustomizer.collection.image_size + "x")));
                        },
                    },
                    {
                        key: "changePrice",
                        value: function (t, e, r) {
                            var n = t.querySelector(this.priceRegularSelectors),
                                i = t.querySelectorAll(this.priceCompareSelectors);
                            e
                                ? (n && (n.innerHTML = this.formatMoney(e.price)),
                                  i.length &&
                                      i.forEach(function (t) {
                                          t && (t.style.display = "none");
                                      }))
                                : Object.keys(r.currentSelected).length === r.optionWithValues.length && n && (n.innerHTML = "Unavailable");
                        },
                    },
                    {
                        key: "doSelectOnInit",
                        value: function (t, e) {
                            t.forEach(function (t) {
                                var r;
                                (null !== (r = varioSettings[t.name]) && void 0 !== r && r.display_on_collection) || (e.availableVariants.length && (e.doSelect(t.name, e.availableVariants[0][t.name]), e.disableSwatch()));
                            });
                        },
                    },
                ]),
                t
            );
        })();
    (Pn = function () {
        var t = window.meta.page.pageType;
        "collection" === t
            ? (885 === Shopify.theme.theme_store_id && document.body.classList.add("vario-body"), (window.VarioCollection = new Nn()))
            : "product" === t &&
              setTimeout(
                  function () {
                      (window.VarioProduct = new Fn()), window.VarioProduct.init();
                  },
                  "undefined" != typeof wetheme ? 200 : 1
              );
    }),
        (document.attachEvent ? "complete" === document.readyState : "loading" !== document.readyState) ? Pn() : document.addEventListener("DOMContentLoaded", Pn);
})();
